import { grassedWaterwayCols, lengthAndSlope, linedWaterwayCols, parabolicCols, reachViewBeforeCols, stationViewAfterCols, stationViewBeforeCols, stationViewCols, trapezoidalCols } from './../../../config';
import { IProfileSettingsForm, initialFormValidationReachTable, profileSettingsFormDefault } from '../../../config';
import stores from "cd-eft/models/Stores";
import { DynamicWaterwayTableStore } from "cd-eft/models/Stores/DynamicProfile/Waterway/DynamicWaterwayTableStore";
import { action, computed, observable, reaction } from "mobx";
import { DynamicWaterwayProfileStore } from "cd-eft/models/Stores/DynamicProfile/Waterway/DynamicWaterwayProfileStore";
import { WaterwayDesignToolsController, WaterwayDesignToolsReachJsonController, ProfileController } from 'cd-eft/services/eftSetApi';
import { EftProjUserInputController } from 'cd-eft/services/eftPrjAdminApi'
import { AppConstants } from 'cd-eft/appConstants';
import { DesignContainerVM } from 'cd-eft/components/Design/DesignContainer/DesignContainerVM';
import MapView from "@arcgis/core/views/MapView.js";
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import { toDecimalPrecision } from 'cd-eft/utils/mathUtilities';
import { IWaterwayVertexParamDTO, convertStationBasedOnWaterwayVertexParamDTO, IWaterwayDesignStation } from 'cd-eft/models/Stores/WaterwayDesignStore';
import { capAndUnderscore, testDecimalString, testStationString, toTitleFromUnderscore } from "cd-eft/utils/stringUtilities";
import { GraphicsLayer, GroupLayer, Point } from "cd-eft/utils/esriTypes";
import { saveScreenshot } from 'cd-eft/utils/gisUtils';
import Extent from "@arcgis/core/geometry/Extent";
import sleep from 'cd-eft/utils/sleep';
import { AlignedElementUiStateDto, UiSettingsDto, EftProjUserInputDto } from "cd-eft/_codegen_/openapi-generator/eft-prjadmin/api";
import { XyzPoint } from "cd-eft/models/SurveyEngineering/XyzPoint";
import { DynamicWaterwayMapStore } from 'cd-eft/models/Stores/DynamicProfile/Waterway/DynamicWaterwayMapStore';
import { parseStationString, formatStationString } from 'cd-eft/utils/stationUtilities';
import axios from 'axios';
import AppStore from 'cd-eft/models/Stores/AppStore';
import { getDimensionsForImage } from 'cd-eft/utils/imageUtils';
import { shiftElevationCallback } from 'cd-eft/models/Stores/DesignStore';

const { surveyEngineeringStore: surveyEngStore, designStore, waterwayDesignStore: waterwayStore } = stores.AppStore;

interface ISelection {
    name: string;
    value: string;
}

export class WaterwayDesignVM {
    private tableStore!: DynamicWaterwayTableStore;

    public profileStore!: DynamicWaterwayProfileStore;
    @observable waterwaySummaryReportObj: any = [];
    @observable props;
    @observable channelControl;
    @observable currentObject;
    @observable mapView?: MapView;
    @observable changedInputValue: boolean = false;
    @observable headerTitle = "";
    @observable onClickInformation = false;
    @observable waterwayName = "";
    @observable waterWayWizardStatus: number = 1;  // 1: default, 2: success, 3:error
    @observable profileSettingsForm: IProfileSettingsForm = profileSettingsFormDefault;
    @observable savedProfileSettingsForm: IProfileSettingsForm = profileSettingsFormDefault;
    @observable hasWaterwayCalculations: boolean = false;
    @observable saveButtonPopup: boolean = false;
    private startEditing: boolean = false;
    @observable isEnableSaveCalculate = false;
    @observable prevStartSlopeDistance: number = 0;
    @observable prevEndSlopeDistance: number = 0;
    @observable prevStartSlopePercentage: number = 0;
    @observable prevEndSlopePercentage: number = 0;
    @observable selectedWaterwayStationForWSC: string | null = null;
    @observable openedFromWarningIcon: boolean = false;
    linedWaterwayElementActions: { [key: string]: { action: any, disabled?: boolean } };
    @observable selectedLiningMaterial: string = '';
    @observable updateTrigger: number = 0;
    @observable isWscLoading: boolean = false;
    // props passed to Manual Entry component
    @observable selectedReachLiningMaterial = {
        liningMaterialName: '',
        manning: 0,
        thickness: 0
    }
    // isLiningMaterialPopupOpen[0]-> enabler; isLiningMaterialPopupOpen[1]->reachId as key for manual entry component
    @observable isLiningMaterialPopupOpen = [false, ''];
    @observable waterwayResultsComment: string = '';

    @computed get waterwaySummaryBannerReportObj(): any {
        return waterwayStore.waterwaySummaryBannerReportObj;
    }

    // fixed width/depth
    fixedWidthOrDepth: 'depth' | 'width' | 'none' = 'none';
    @observable fixedValue = 0.0.toFixed(1);
    private cancelFlag = false;

    // shift elevation
    @observable shiftElevation = 0.0.toFixed(1);

    // ai design experimental code
    @observable minStation = 25;
    @observable maxStation = 425;
    @observable stationInterval = 100;
    @observable cupDepth = 1.5;
    @observable liningMaterial = "Concrete (0.0130,10)";
    //End: ai design experimental code

    // truncate waterway
    private waterwayTruncated: boolean = false;
    private storedWaterwayStations;
    private storedEdits: any[] = [];
    private startEndStationsUpdated: boolean = false;

    private previousAddedQ = 0;
    private previousStation = '0+00';
    private previousFlowDepthFB = 0;
    private previousFlowTopWidth = 0;
    private watchEditingHandle1;
    private watchEditingHandle2;
    private watchEditingHandle3;

    @observable formValidation = {
        formErrors: {
            fineGrid: '',
            lowBankOffset: '',
            sampleInterval: '',
            verticalInterval: '',
        },
        fineGridValid: true,
        lowBankOffsetValid: true,
        sampleIntervalValid: true,
        verticalIntervalValid: true,
        formValid: true
    }
    @observable formValidationReachTable = { ...initialFormValidationReachTable };

    get inputSkipped() {
        return (
            !waterwayStore.uiState || waterwayStore.uiState === 'WaterwayInputSave'
        );
    }

    get saveCalculateButtonStatus() {
        return (
            !this.currentObject ||
            !this.currentObject.alignedElementDesignParametersId ||
            !this.currentObject.waterwayDesignStations ||
            this.currentObject.waterwayDesignStations.length === 0 ||
            this.formValidationReachTable.invalidFields.length > 0 ||
            waterwayStore.waterwayDesignObject.disableCalculateButtonDesignPage
        );
    }

    get saveButtonStatus() {
        return (
            !this.currentObject ||
            !this.currentObject.alignedElementDesignParametersId ||
            !this.currentObject.waterwayDesignStations ||
            this.currentObject.waterwayDesignStations.length === 0 ||
            this.formValidationReachTable.invalidFields.length > 0 ||
            waterwayStore.waterwayDesignObject.DisableSaveButtonDesignPage
        );
    }

    get generateSurfaceButtonStatus() {
        return (
            // this.disableGenerateSurface||
            !waterwayStore.waterwayDesignObject.hasWaterwayCalculations ||
            !this.currentObject ||
            !this.currentObject.alignedElementDesignParametersId ||
            !this.currentObject.waterwayDesignStations ||
            this.currentObject.waterwayDesignStations.length === 0 ||
            this.currentObject.waterwayDesignStations.find(
                (waterwayDesignStation) =>
                    waterwayDesignStation.status === 'ERROR' || waterwayDesignStation.status === 'IN PROGRESS'
            ) ||
            waterwayStore.uiState === 'ReachDesignSurface'
        );
    }

    get deleteStationButtonStatus() {
        return (
            this.currentObject?.waterwayDesignStations?.find((station) => station.reachId === 'R-2')
        );
    }

    get readyHumanFeedback(): boolean {
        return this.tableStore.humanFeedbackData.length < 1;
    }

    get hitUplimitHumanFeedback(): boolean {
        return this.tableStore.humanFeedbackData.length >= 5;
    }


    @action.bound resetValues = async () => {
        if (this.profileStore.alignmentCenterLine.length > 0 && designStore.toggleResetValues) {
            this.currentObject = waterwayStore.waterwayDesignObject;
            const lowBank = waterwayStore.profileSettings.bankProfile === 'showMergedLowBank' ? true : false;
            const bankOffset = Number(waterwayStore.profileSettings.lowBankOffset);
            const sampleInterval = waterwayStore.profileSettings.sampleInterval;
            const verticalInterval = waterwayStore.profileSettings.verticalInterval;
            await this.profileStore.generateCenterlineAndBank(lowBank, bankOffset, sampleInterval, verticalInterval);
            await this.profileStore.createReachLineFromSavedWaterway();
            designStore.toggleResetValues = false;
        }
    };

    @action.bound async selectReachForWSC(reachId: string) {
        this.selectedWaterwayStationForWSC = reachId;

        // Always add the selected reach, even if it's already in the array
        if (!waterwayStore.selectedWaterwayStations.includes(reachId)) {
            waterwayStore.selectedWaterwayStations.push(reachId);
        }

        // Special case for R-1
        if (reachId === 'R-1' && !waterwayStore.selectedWaterwayStations.includes("R-0")) {
            waterwayStore.selectedWaterwayStations.push("R-0");
        }
        if (waterwayStore.openedFromWarningIcon) {
            const reach = this.currentObject.waterwayDesignStations.find(s => s.reachId === reachId);
            if (reach?.error) {
                const errorParts = reach.error.split('\n');
                waterwayStore.WSCstatus = reach.status;

                const errorCodes: string[] = [];
                for (const part of errorParts) {
                    if (part.trim().startsWith('WDT_')) {
                        errorCodes.push(part.trim());
                    }
                }

                waterwayStore.WSCstatusErrorCode = errorCodes.join(', ');
                waterwayStore.hasChannelDimensionsError = true;
                const designChannelMessage = errorParts.find(part =>
                    part.includes("Design channel is") &&
                    part.includes("ft wide x") &&
                    part.includes("ft deep")
                ) || "";

                const errorMessages: string[] = [];
                if (designChannelMessage) {
                    errorMessages.push(designChannelMessage.trim());
                }

                const otherErrorCodes = errorCodes.filter(code =>
                    !code.includes("WDT_20") && !code.includes("WDT_21")
                );

                if (otherErrorCodes.length > 0) {
                    try {
                        for (const code of otherErrorCodes) {
                            const message = await MessageCenter.getMessageFromCode(code);
                            if (message && !errorMessages.includes(message)) {
                                errorMessages.push(message);
                            }
                        }
                    } catch (error) {
                        console.error("Error getting error messages:", error);
                    }
                }

                waterwayStore.WSCstatusErrorMessage = errorMessages.join(', ');

                if (waterwayStore.WSCstatusErrorMessage === '') {
                    waterwayStore.WSCstatusErrorMessage = errorParts[errorParts.length - 1];
                }
            }
        }
        waterwayStore.selectReachForWSC(reachId);
        const station = this.currentObject.waterwayDesignStations.find(s => s.reachId === reachId);
        if (station) {
            const stationX = designStore.commonHorizontalStretchFactor
                ? (parseFloat(station.station.replace('+', '')) * designStore.commonHorizontalStretchFactor)
                : parseFloat(station.station.replace('+', ''));
            const point = new Point({
                x: stationX,
                y: station.channelZ * (designStore.commonVerticalStretchFactor || AppConstants.profileStretchFactor),
                spatialReference: this.profileStore._profileView?.spatialReference
            });
            this.profileStore.trackProfilePoint(point, reachId);
            this.applySVC(null, station);
        }
        waterwayStore.updateSelectedReachNames();
        waterwayStore.displayWscComponent();

        if (waterwayStore.openedFromWarningIcon) {
            this.isWscLoading = true;
            try {
                await new Promise(resolve => requestAnimationFrame(resolve));
                if (waterwayStore.wscComponentRef) {
                    // Wait for both API calls to complete and data to be processed
                    const soilStrengthParams = waterwayStore.wscComponentRef.soilStrengthVM.getParameters();
                    const vegetalParams = waterwayStore.wscComponentRef.vegetalCoverVM.getVegetalParameters();
                    await Promise.all([soilStrengthParams, vegetalParams]);
                    await waterwayStore.wscComponentRef.finalCalculation();
                    waterwayStore.openedFromWarningIcon = false;
                }
            } finally {
                this.isWscLoading = false;
            }
        }
    }

    @action.bound handleCloseDesignCalculator() {
        waterwayStore.closeWscComponent();
    }

    @action.bound toggleReport() {
        this.saveButtonPopup = true;
        this.getWaterwaySummaryReport();
        return;
    }

    @action.bound profileSettingsBankOnSelection(event) {
        const { name, value } = event.target;
        this.profileSettingsForm.showBankSelection = name;
    }

    elementActions = {
        'S/V/C-WSC': {
            action: (e: any, item: any) => {
                this.selectReachForWSC(item.reachId);
                return this.applySVC(e, item);
            }
        },
    };

    constructor(props: any, onInvalidFieldsChange: (hasInvalidFields: boolean) => void = () => { }) {
        this.channelControl = waterwayStore.channelControl;
        this.props = props;
        this.linedWaterwayElementActions = this.getLinedWaterwayElementActions();


        // if (waterwayStore.wdtGroupsOriginals.length > 0 && waterwayStore.wdtGroupsOriginals[0]) {
        //     waterwayStore.wdtGroupsOriginals[0].currentObject.editingStatus = !waterwayStore.currentElement.id ? 'add' : 'update';
        //     waterwayStore.wdtGroupsOriginals[0].currentObject.surfaceDefId = designStore.currentSurface.surfaceDefId;
        //     waterwayStore.wdtGroupsOriginals[0].currentObject.surfaceDefTitle = designStore.currentSurface.surfaceDefTitle;
        //     waterwayStore.wdtGroupsOriginals[0].currentObject.sessionId = designStore.projectsStore.currentSessionId;
        //     waterwayStore.wdtGroupsOriginals[0].currentObject.alignedElementDesignParametersId = waterwayStore.alignedDesignElementId;
        // }
        waterwayStore.waterwayDesignObject.editingStatus = !waterwayStore.currentElement.id ? 'add' : 'update';
        waterwayStore.waterwayDesignObject.surfaceDefId = designStore.currentSurface.surfaceDefId;
        waterwayStore.waterwayDesignObject.surfaceDefTitle = designStore.currentSurface.surfaceDefTitle;
        waterwayStore.waterwayDesignObject.sessionId = designStore.projectsStore.currentSessionId;
        waterwayStore.waterwayDesignObject.alignedElementDesignParametersId = waterwayStore.alignedDesignElementId;
        this.currentObject = waterwayStore.waterwayDesignObject;

        // Clone object on reload if reaches exist
        if (waterwayStore.waterwayDesignObject.waterwayDesignStations.length > 0) {
            waterwayStore.wdtGroupsOriginals = [];
            waterwayStore.wdtGroupsOriginals.push(
                {
                    groupCount: 0,
                    currentObject: JSON.parse(JSON.stringify(waterwayStore.waterwayDesignObject))
                }
            );
        }
        this.mapView = DesignContainerVM.mapView;
        if (props.profileTableStore) {
            this.tableStore = props.profileTableStore;
            this.tableStore.setStore = surveyEngStore;
            this.tableStore.waterwayStore = waterwayStore;
            this.tableStore.CurrentObject = waterwayStore.waterwayDesignObject;
        }

        if (props.profileStoreRef) {
            this.profileStore = props.profileStoreRef;
        }

        this.profileStore.deleteAction = (index: number) => {
            this.waterwayDesignStationToDelete.reachId = 'R-' + index;
            this.toggleDeleteStationDialog();
        }

        this.getErrors();
        reaction(
            () => this.formValidationReachTable.invalidFields.length,
            (length) => {
                onInvalidFieldsChange(length > 0);
                designStore.allFieldsValids = length > 0 ? false : true;
            }
        );
    }


    getLinedWaterwayElementActions() {
        return {
            'Update Lining Material': {
                action: (event: any, item: any) => {
                    if (item && item.reachId) {
                        const index = this.currentObject.waterwayDesignStations.findIndex(s => s.reachId === item.reachId);
                        this.handleCheckboxChange({ target: { checked: true } }, index);
                        this.openLiningMaterialPopup(item.capacity, item.reachId);
                    }
                }
            },
        };
    }

    @action.bound openLiningMaterialPopup(capacity, reachId) {
        capacity = capacity.replace('D₅₀=6in Rock Riprap', 'D50=6in Rock Riprap')
        const parsedList = capacity.split('(');
        const liningMaterialName = parsedList[0].trim();
        const match = capacity.match(/\(([^,]{1,6}), ([^)]{1,5})\)/);
        const manning = parseFloat(match[1]);
        const thickness = parseFloat(match[2]);
        this.selectedReachLiningMaterial = { liningMaterialName: liningMaterialName, manning: manning, thickness: thickness }
        this.isLiningMaterialPopupOpen = [true, reachId];
    }


    @observable activeTab: string = 'combined-view';

    @action.bound changeTab = (selectedTab) => {
        if (this.activeTab !== selectedTab) this.activeTab = selectedTab;
        waterwayStore.tableView = selectedTab[0].toUpperCase();
    };

    private resizeWatchHandler;

    private handleMouseDownResize = (e) => {
        const resizableElement = document.getElementById('wdt-top-container');
        const containerDiv = document.getElementById('WDT-content');
        const currentViewExtent = this.profileStore._profileView?.extent;

        if (resizableElement && containerDiv) {
            const rect = resizableElement.getBoundingClientRect();
            const container = containerDiv.getBoundingClientRect();
            const minHeight = 20;
            const startHeight = rect.height;
            const startY = e.clientY;
            const maxHeight = container.height - 32;
            const handleMouseMoveResize = (e) => {
                document.body.style.userSelect = 'none';
                const deltaY = e.clientY - startY;
                const height = startHeight + deltaY;
                if (height > minHeight && height < maxHeight) {
                    resizableElement.style.height = height + 'px';
                    resizableElement.style.minHeight = height + 'px';
                    resizableElement.style.maxHeight = height + 'px';
                }
            }
            const handleMouseUpResize = async () => {
                window.removeEventListener('mousemove', handleMouseMoveResize);
                window.removeEventListener('mouseup', handleMouseUpResize);
                document.body.style.userSelect = 'auto';
                if (this.profileStore._profileView && currentViewExtent) {
                    this.profileStore._profileView.extent = currentViewExtent;
                    await this.profileStore.redrawMappingProfiles();
                    await this.profileStore.createReachLineFromSavedWaterway();
                }
            }
            window.addEventListener('mousemove', handleMouseMoveResize);
            window.addEventListener('mouseup', handleMouseUpResize);
        }
    }

    private windowResizeWatchHandler;

    private handleWindowResize = (e) => {
        const resizableElement = document.getElementById('wdt-top-container');

        if (resizableElement) {
            const actionsOnWindowResize = (e) => {
                window.removeEventListener('resize', actionsOnWindowResize);
                resizableElement.style.height = '';
                resizableElement.style.minHeight = '';
                resizableElement.style.maxHeight = '';
            }
            window.addEventListener('resize', actionsOnWindowResize);
        }
    }

    @observable reachViewAfterCols: any[] = [];
    @observable combinedCols: any[] = [];
    @observable reachCols: any[] = [];
    @observable waterwayTabs: any[] = [];

    @action.bound setReachTableFields = () => {
        // *** reachViewAfterCols ***
        const reachViewAfterCols1 = [
            {
                name: 'flowDepthFB',
                title: 'Flow Depth + FB\n(ft)',
                editable: true,
                edtableOnR0: true,
                blankOnStartAndEnd: true,
            },
            {
                name: 'flowTopWidth',
                title: 'Flow Top Width\n(ft)',
                editable: true,
                editablieOnR0: true,
                blankOnStartAndEnd: true,
            },
        ];

        // *** Lined or Grass ***
        if (waterwayStore.currentWaterwayDesignElementTypeId === 19) {
            this.reachViewAfterCols = [...reachViewAfterCols1, ...linedWaterwayCols];
        } else {
            this.reachViewAfterCols = [...reachViewAfterCols1, ...grassedWaterwayCols];
        }

        // *** Combined View ***
        const combinedCols1 = [...reachViewBeforeCols, ...stationViewBeforeCols, ...lengthAndSlope];
        const combinedColsEnd = [...stationViewAfterCols, ...this.reachViewAfterCols];
        if (waterwayStore.channelControl === 'PARABOLIC') {
            this.combinedCols = [...combinedCols1, ...parabolicCols, ...combinedColsEnd];
        } else if (waterwayStore.channelControl === 'TRAPEZOIDAL') {
            this.combinedCols = [...combinedCols1, ...trapezoidalCols, ...combinedColsEnd];
        }

        // *** Reach View ***
        const reachCols1 = [...reachViewBeforeCols, ...lengthAndSlope];
        if (waterwayStore.channelControl === 'PARABOLIC') {
            this.reachCols = [...reachCols1, ...parabolicCols, ...this.reachViewAfterCols];
        } else if (waterwayStore.channelControl === 'TRAPEZOIDAL') {
            this.reachCols = [...reachCols1, ...trapezoidalCols, ...this.reachViewAfterCols];
        }

        this.waterwayTabs = [
            { tab: 'combined-view', title: 'Combined View', defaultCols: this.combinedCols },
            { tab: 'station-view', title: 'Station View', defaultCols: stationViewCols },
            { tab: 'reach-view', title: 'Reach View', defaultCols: this.reachCols },
        ];
    };

    @action.bound async onMount() {
        if (designStore.displayResultBanner) {
            await this.getWaterwaySummaryBannerReportObj()
        }
        if (waterwayStore.tableView === 'R') {
            this.changeTab('reach-view')
        } else if (waterwayStore.tableView === 'S') {
            this.changeTab('station-view')
        } else {
            this.changeTab('combined-view')
        }
        const separator = document.getElementById('wdt-separator');
        this.resizeWatchHandler = separator?.addEventListener('mousedown', this.handleMouseDownResize.bind(this));
        this.windowResizeWatchHandler = window.addEventListener('resize', this.handleWindowResize.bind(this));
    }

    @action.bound setWaterwayResultsComment = () => {
        this.waterwayResultsComment = waterwayStore.waterwaySummaryBannerReportObj!.waterwayName!;
    }

    @action.bound unMount() {
        waterwayStore.renderWaterwayDesign = false;
        waterwayStore.selectedWaterwayStations = [];
        designStore.commonHorizontalStretchFactor = undefined;
        designStore.commonVerticalStretchFactor = undefined;
        this.resizeWatchHandler?.remove();
        this.windowResizeWatchHandler?.remove();
    }

    @action.bound setElementActions(tab: string, widthEdited: boolean, depthEdited: boolean) {
        const stationViewActions = {
            'Insert Station': { action: this.insertStationTableView },
            'Delete Station': { action: this.setWaterwayDesignStationToDelete, disabled: !this.deleteStationButtonStatus }
        };
        const isLiningWaterway = waterwayStore.waterwayType === 'Lined Waterway' || waterwayStore.currentWaterwayDesignElementTypeId === 19;
        let actions = { ...(isLiningWaterway ? this.linedWaterwayElementActions : this.elementActions) };
        const resetReachName = isLiningWaterway ? 'Reset Reach' : 'Reset Reach - WSC';
        const reachViewAction = { [resetReachName]: { action: this.resetSVC } };
        const isCrossSectionToolEnabled = waterwayStore.uiState === 'ReachDesignSurface' || waterwayStore.uiState === 'ReachDesignCalculate';
        // Add other actions based on the tab
        if (tab === 'combined-view') {
            actions = {
                ...actions,
                ...stationViewActions,
                ...reachViewAction,
                'Cross Section Tool': { action: this.crossSectionTool, disabled: !isCrossSectionToolEnabled },
                'Reset Fixed Width': { action: this.resetFlowWidth, disabled: !widthEdited },
                'Reset Fixed Depth': { action: this.resetFlowDepth, disabled: !depthEdited }
            };
        } else if (tab === 'station-view') {
            actions = {
                ...actions,
                ...stationViewActions,
                'Cross Section Tool': { action: this.crossSectionTool, disabled: !isCrossSectionToolEnabled },
            };
        } else if (tab === 'reach-view') {
            actions = {
                ...actions,
                ...reachViewAction,
                'Cross Section Tool': { action: this.crossSectionTool, disabled: !isCrossSectionToolEnabled },
                'Reset Fixed Width': { action: this.resetFlowWidth, disabled: !widthEdited },
                'Reset Fixed Depth': { action: this.resetFlowDepth, disabled: !depthEdited }
            };
        }

        return actions;
    }

    get waterwayProfileActions() {
        const retObj = {
            'Generate Reaches (non-MVP)': { action: this.setGenerateReaches, disabled: this.inputSkipped || !designStore.shouldHumanFeedbackOn },
            // 'Generate Reaches (non-MVP)': { action: () => { alert("Function Under Construction.") }, disabled: this.inputSkipped || !designStore.shouldHumanFeedbackOn },
            'Shift Waterway Elevation': { action: this.setShiftElevation, disabled: this.inputSkipped },
            'Set Fixed Width': { action: this.setFixedWidth, disabled: this.inputSkipped },
            'Reset Fixed Widths': { action: this.resetAllFlowWidth, disabled: !this.currentObject.waterwayDesignStations.some((el) => el.widthEdited) },
            'Set Fixed Depth': { action: this.setFixedDepth, disabled: this.inputSkipped },
            'Reset Fixed Depths': { action: this.resetAllFlowDepth, disabled: !this.currentObject.waterwayDesignStations.some((el) => el.depthEdited) },
            // 'Reset All': { action: this.toggleResetSettingDialog }
        }
        // ai design experimental code
        /* istanbul ignore if */
        if (AppStore.userProfileStore.applicationFlags.enabledrlwaterway) {
            const newAttribue = 'AI Assisted Designer';
            retObj[newAttribue] = { action: action(() => { this.openAiDesignPanel = true; this.profileStore.turnOffWaterwayReaches(); }), disabled: false };
        }

        return retObj;
    }

    @action.bound async generateInitialProfiles() {
        // Added to prevent calls to generate alignment/reach profiles when on an "empty" design.
        // If no waterway id has been saved yet, return early and don't run profile generation.
        if (!waterwayStore.alignedDesignElementId) {
            return
        }
        while (!waterwayStore.loadingComplete) {
            await new Promise(resolve => setTimeout(resolve, 100));
        }
        const lowBank = waterwayStore.profileSettings.bankProfile === 'showMergedLowBank' ? true : false;
        const bankOffset = Number(waterwayStore.profileSettings.lowBankOffset);
        const sampleInterval = waterwayStore.profileSettings.sampleInterval;
        const verticalInterval = waterwayStore.profileSettings.verticalInterval;
        await this.profileStore.generateCenterlineAndBank(lowBank, bankOffset, sampleInterval, verticalInterval);
        let gridValue: number = 0;
        if (waterwayStore.profileSettings.showCoord) {
            gridValue = Number(waterwayStore.profileSettings.fineGrid);
            this.profileStore.updateGridValues(gridValue);
        } else {
            this.profileStore.updateGridValues(0);
        }
        await this.truncateReachesOutsideControlLimit();
        await this.profileStore.createReachLineFromSavedWaterway();
    }

    @action.bound openSettings() {
        MessageCenter.clearMessages();
        this.profileSettingsForm = JSON.parse(JSON.stringify(this.savedProfileSettingsForm));
        this.profileSettingsForm.profileSettingPopUpActive = true;
    }

    @action.bound saveProfileSettingsFromDesignStoreToLocal() {
        this.savedProfileSettingsForm.showBankSelection = waterwayStore.profileSettings.bankProfile as "showMergedLowBank" | "showLeftRightBanks";
        this.savedProfileSettingsForm.input.fineGrid = waterwayStore.profileSettings.fineGrid;
        this.savedProfileSettingsForm.input.lowBankOffset = waterwayStore.profileSettings.lowBankOffset;
        this.savedProfileSettingsForm.input.sampleInterval = waterwayStore.profileSettings.sampleInterval;
        this.savedProfileSettingsForm.checked.showFineGrid = waterwayStore.profileSettings.showCoord;
        this.savedProfileSettingsForm.input.verticalInterval = waterwayStore.profileSettings.verticalInterval;
    }
    @action.bound saveProfileSettingsFromLocalToDesignStore() {
        waterwayStore.profileSettings.bankProfile = this.savedProfileSettingsForm.showBankSelection;
        waterwayStore.profileSettings.fineGrid = this.savedProfileSettingsForm.input.fineGrid;
        waterwayStore.profileSettings.lowBankOffset = this.savedProfileSettingsForm.input.lowBankOffset;
        waterwayStore.profileSettings.sampleInterval = this.savedProfileSettingsForm.input.sampleInterval;
        waterwayStore.profileSettings.showCoord = this.savedProfileSettingsForm.checked.showFineGrid;
        waterwayStore.profileSettings.verticalInterval = this.savedProfileSettingsForm.input.verticalInterval;
    }

    @action.bound handleCancelProfileSettings() {
        // reset parameters
        this.profileSettingsForm = JSON.parse(JSON.stringify(this.savedProfileSettingsForm));
        this.profileSettingsForm.profileSettingPopUpActive = false;
    }
    @action.bound async handleSaveProfileSettings() {
        let profileParametersChanged: boolean = false;
        if (this.profileSettingsForm.input.lowBankOffset !== this.savedProfileSettingsForm.input.lowBankOffset
            || this.profileSettingsForm.input.sampleInterval !== this.savedProfileSettingsForm.input.sampleInterval
            || this.profileSettingsForm.input.verticalInterval !== this.savedProfileSettingsForm.input.verticalInterval
            || this.profileSettingsForm.showBankSelection !== this.savedProfileSettingsForm.showBankSelection
            || this.profileSettingsForm.checked.showFineGrid !== this.savedProfileSettingsForm.checked.showFineGrid
            || this.profileSettingsForm.input.fineGrid !== this.savedProfileSettingsForm.input.fineGrid) {
            profileParametersChanged = true;
        }

        this.profileSettingsForm.profileSettingPopUpActive = false;
        this.savedProfileSettingsForm = JSON.parse(JSON.stringify(this.profileSettingsForm));
        // update centerline and bank profiles and ProfileRequestDTO API call
        const lowBank = this.profileSettingsForm.showBankSelection === 'showMergedLowBank' ? true : false;
        const bankOffset = Number(this.profileSettingsForm.input.lowBankOffset);
        const sampleInterval = this.profileSettingsForm.input.sampleInterval;
        const verticalInterval = this.profileSettingsForm.input.verticalInterval;

        if (profileParametersChanged) {
            await this.profileStore.generateCenterlineAndBank(lowBank, bankOffset, sampleInterval, verticalInterval);
            waterwayStore.waterwayDesignObject.DisableSaveButtonDesignPage = false;
            waterwayStore.waterwayDesignObject.disableCalculateButtonDesignPage = false;
            waterwayStore.waterwayDesignObject.hasWaterwayCalculations = false;
        }

        let gridValue: number = 0;
        if (this.profileSettingsForm.checked.showFineGrid) {
            gridValue = Number(this.profileSettingsForm.input.fineGrid);
            this.profileStore.updateGridValues(gridValue);
        } else {
            this.profileStore.updateGridValues(0);
        }
    }

    // @action.bound resetPreview() {
    //     if (this.profileSettingsForm.checked.previews) {
    //         this.profileSettingsForm.checked.previews = false
    //         this.profileStore.updateGridValues(0);
    //     }
    // }

    @action.bound toggleFineGrid() {
        this.profileSettingsForm.checked.showFineGrid = !this.profileSettingsForm.checked.showFineGrid;
        // this.resetPreview();
    }

    // ai design experimental code
    /* istanbul ignore next */
    @action.bound
    toggleAiDesignPanel() {
        this.openAiDesignPanel = false;
    }

    // NOTE: If we ever re-implement preview on waterway, check the new way it's done in ThreeCrossSectionVM.
    // @action.bound previewProfileSettingsHandler() {
    //     this.profileSettingsForm.checked.previews = !this.profileSettingsForm.checked.previews;
    //     if (this.profileSettingsForm.checked.previews && this.profileSettingsForm.checked.showFineGrid) {
    //         this.profileStore.updateGridValues(Number(this.profileSettingsForm.input.fineGrid));
    //     } else {
    //         this.profileStore.updateGridValues(0);
    //     }
    // }

    // Digitize waterwayDesign reaches -->
    @observable redigitizeReachesDialogIsOpen: boolean = false;

    /* istanbul ignore next */
    @action.bound toggleRedigitizeReachesDialog() {
        this.redigitizeReachesDialogIsOpen = !this.redigitizeReachesDialogIsOpen;
    }

    /* istanbul ignore next */
    @action.bound sketchReach(e: any) {
        e.preventDefault();
        if (this.profileStore.checkSketch()) {
            this.toggleRedigitizeReachesDialog();
        } else {
            this.digitizeReaches();
        }
    }

    /* istanbul ignore next */
    @action.bound async digitizeReaches() {
        if (this.redigitizeReachesDialogIsOpen) this.toggleRedigitizeReachesDialog();
        try {
            await WaterwayDesignToolsReachJsonController.deleteReachByAlignedElementDesignParametersIdUsingPOST(waterwayStore.waterwayDesignObject.alignedElementDesignParametersId);
            await this.saveUiState('digitizeReaches');
            await this.getUiStateAndNotification();
            this.props.resetPEMReachEdits();
            waterwayStore.waterwaySummaryBannerReportObj = undefined;
            waterwayStore.selectedWaterwayStations = [];
            designStore.displayResultBanner = false;
            this.profileStore.sketchPolyline(this.saveUiState, this.getUiStateAndNotification);


            // Reset formValidationReachTable to its default state
            this.formValidationReachTable = { ...initialFormValidationReachTable };
        } catch (error) {
            MessageCenter.addError((error as Error).message);
        }
    }

    /* istanbul ignore next */
    @action.bound insertVertex(e: any) {
        e.preventDefault();
        waterwayStore.selectedWaterwayStations = [];
        this.profileStore.unTrackProfilePoints();
        this.startEditingMode();
        this.profileStore.SketchPoint(this.props.addWDTEdits);
    }

    /* istanbul ignore next */
    @action.bound async resetSVC(e: any, item: IWaterwayDesignStation, i: any) {
        let response;
        let data;

        try {
            if (waterwayStore.waterwayType === 'Lined Waterway' || waterwayStore.currentWaterwayDesignElementTypeId === 19) {
                response = await WaterwayDesignToolsController.resetDefaultLinedReachUsingGET(this.currentObject.alignedElementDesignParametersId, item.reachId);
                if (response && response.data && response.data.waterwayVertexParamDTOList && response.data.waterwayVertexParamDTOList.length > 1) {
                    data = response.data.waterwayVertexParamDTOList[1];
                }
            } else {
                response = await WaterwayDesignToolsReachJsonController.getWaterwayVertexParamDTOForDefaultWscByReachIdAndAlignedElementDesignParametersIdUsingGET(this.currentObject.alignedElementDesignParametersId, item.reachId);
                data = response.data;
            }
            if (data) {
                const station = waterwayStore.waterwayDesignObject.waterwayDesignStations[i];

                const reachValuesFromDb = {
                    leftSS: data.channelParams ? Number(toDecimalPrecision(data.channelParams.leftSlopeRatio, 0)) : 0,
                    bottomWidth: data.channelParams ? Number(toDecimalPrecision(data.channelParams.minBedWidth, 0)) : 0,
                    rightSS: data.channelParams ? Number(toDecimalPrecision(data.channelParams.rightSlopeRatio, 0)) : 0,
                    offset1: data.channelParams ? Number(toDecimalPrecision(data.channelParams.offset1, 0)) : 0,
                    offset2: data.channelParams ? Number(toDecimalPrecision(data.channelParams.offset2, 0)) : 0,
                    offset3: data.channelParams ? Number(toDecimalPrecision(data.channelParams.offset3, 0)) : 0,
                    flowDepthFB: data.simDepth ? Number(data.simDepth.toLocaleString("en", { maximumFractionDigits: 1, minimumFractionDigits: 1, useGrouping: false })) : 0,
                    flowTopWidth: data.simWidth ? Number(data.simWidth.toLocaleString("en", { maximumFractionDigits: 1, minimumFractionDigits: 1, useGrouping: false })) : 0,
                    stabVelocity: data.stabVelocity ? Number(data.stabVelocity.toLocaleString("en", { maximumFractionDigits: 2, minimumFractionDigits: 2, useGrouping: false })) : 0,
                    capaVelocity: data.capaVelocity ? Number(data.capaVelocity.toLocaleString("en", { maximumFractionDigits: 2, minimumFractionDigits: 2, useGrouping: false })) : 0,
                    soilStrength: data.soilStrength ? toTitleFromUnderscore(data.soilStrength) : '',
                    vegCover: data.vegetalCover ? data.vegetalCover : '',
                    stability: data.stability ? data.stability : '',
                    capacity: data.capacity ? data.capacity : '',
                    error: data.errorCode ? data.errorCode : '',
                };

                // Store original values
                const editedValues = {
                    leftSS: item.leftSS,
                    bottomWidth: item.bottomWidth,
                    rightSS: item.rightSS,
                    offset1: item.offset1,
                    offset2: item.offset2,
                    offset3: item.offset3,
                    flowDepthFB: Number(item.flowDepthFB),
                    flowTopWidth: Number(item.flowTopWidth),
                    stabVelocity: Number(item.stabVelocity),
                    capaVelocity: Number(item.capaVelocity),
                    soilStrength: item.soilStrength,
                    vegCover: item.vegCover,
                    stability: item.stability,
                    capacity: item.capacity,
                    error: item.error
                };

                // Function to check if values have changed
                const haveValuesChanged = (original: typeof reachValuesFromDb, updated: typeof editedValues): boolean => {
                    return Object.keys(original).some(key => original[key] !== updated[key]);
                };

                // Run pending manager code if values have changed
                if (haveValuesChanged(reachValuesFromDb, editedValues)) {
                    // update if they are edited
                    station.leftSS = reachValuesFromDb.leftSS;
                    station.bottomWidth = reachValuesFromDb.bottomWidth;
                    station.rightSS = reachValuesFromDb.rightSS;
                    station.offset1 = reachValuesFromDb.offset1;
                    station.offset2 = reachValuesFromDb.offset2;
                    station.offset3 = reachValuesFromDb.offset3;
                    station.flowDepthFB = reachValuesFromDb.flowDepthFB;
                    station.flowTopWidth = reachValuesFromDb.flowTopWidth;
                    station.stabVelocity = reachValuesFromDb.stabVelocity;
                    station.capaVelocity = reachValuesFromDb.capaVelocity;
                    station.soilStrength = reachValuesFromDb.soilStrength;
                    station.vegCover = reachValuesFromDb.vegCover;
                    station.stability = reachValuesFromDb.stability;
                    station.capacity = reachValuesFromDb.capacity;
                    station.error = reachValuesFromDb.error;
                    // no need since station.capacity = reachValuesFromDb.capacity; above?
                    // if (waterwayStore.waterwayType === 'Lined Waterway' || waterwayStore.currentWaterwayDesignElementTypeId === 19) {
                    //     this.updateLiningMaterial(station.reachId, station.capacity);
                    // }
                    const resetWaterwayVertexData = new Map();
                    const resetStationDTO: IWaterwayVertexParamDTO = convertStationBasedOnWaterwayVertexParamDTO(station, waterwayStore.channelControl);
                    resetWaterwayVertexData.set(station.reachId, resetStationDTO);
                    await this.props.addWDTEdits(resetWaterwayVertexData, false, true);
                }
            }
        } catch (error) {
            console.error("Error resetting the reach:", error);
        }
    }

    @action.bound async crossSectionTool(e: any, item: IWaterwayDesignStation, i: any) {
        waterwayStore.threeCrossSectionTableViewToggle = true;
        designStore.hideThreeCrossSection = false;
        designStore.hideCrossSectionToolbar = false;
        waterwayStore.threeCrossSectionReachID = item.reachId;
        if (item.reachId === waterwayStore.waterwayDesignObject.waterwayDesignStations[waterwayStore.waterwayDesignObject.waterwayDesignStations.length - 2].reachId) {
            waterwayStore.threeCrossSectionReachID = "R-last";
        }
        waterwayStore.threeCrossSectionStation = item.station;
    }


    @action.bound openCrossSectionToolbar() {
        designStore.hideCrossSectionToolbar = !designStore.hideCrossSectionToolbar
        if (designStore.hideCrossSectionToolbar) this.closeCrossSectionToolbar();
    }

    @action.bound closeCrossSectionToolbar() {
        designStore.hideCrossSectionToolbar = true;
        designStore.hideSingleCrossSection = true;
        designStore.hideThreeCrossSection = true;
    }

    @action.bound applySVC(e: any, item: any) {
        waterwayStore.svcProps.slope = Math.abs(parseFloat(item.grade));
        waterwayStore.svcProps.totalQ = item.totalQ;
        waterwayStore.svcProps.leftSS = item.leftSS;
        waterwayStore.svcProps.rightSS = item.rightSS;
        if ((item.soilStrength as string).includes('(')) {
            waterwayStore.svcProps.soilStrengthName = capAndUnderscore(item.soilStrength.split('(')[1].slice(0, -1));
            waterwayStore.svcProps.soilStrengthValue = parseFloat(item.soilStrength.split('(')[0]);
        }
        else {
            waterwayStore.svcProps.soilStrengthValue = parseFloat(item.soilStrength);
            waterwayStore.svcProps.soilStrengthName = undefined;
        }
        if ((item.vegCover as string).includes('(')) {
            let arr = item.vegCover.split("(");
            if (arr.length > 2) {
                arr = [arr[0], arr[1] + "(" + arr[2]]
            }
            waterwayStore.svcProps.vegCoverName = arr[1].slice(0, -1);
            waterwayStore.svcProps.vegCover = parseFloat(arr[0]);
        }
        else {
            waterwayStore.svcProps.vegCover = parseFloat(item.vegCover);
            waterwayStore.svcProps.vegCoverName = '';
        }
        waterwayStore.svcProps.stability = item.stability;
        waterwayStore.svcProps.capacity = item.capacity;
        waterwayStore.svcProps.bottomWidth = item.bottomWidth;
        waterwayStore.svcProps.offset1 = item.offset1;
        waterwayStore.svcProps.offset2 = item.offset2;
        waterwayStore.svcProps.offset3 = item.offset3;
    }

    @action.bound async updateAllReachesLiningMaterial(newMaterial: string) {
        const waterwayDesignStations = this.currentObject.waterwayDesignStations;
        const liningMaterialEditedStationObject = new Map();
        waterwayDesignStations.forEach((station, index) => {
            if (station.reachId !== 'START' && station.reachId !== 'END') {
                this.handleLiningMaterialChangeForReach(newMaterial, index, liningMaterialEditedStationObject);
            }
        });
        if (liningMaterialEditedStationObject.size > 0) {
            await this.props.addWDTEdits(liningMaterialEditedStationObject, true, true);
        }
    }

    // this is not just manual entry, also includes other built-in options
    @action.bound async handleSaveLiningMaterialManualEntry(name, manning, thickness) {
        const liningMaterialString = `${name} (${manning}, ${thickness})`;
        const waterwayDesignStations = this.currentObject.waterwayDesignStations;
        const liningMaterialEditedStationObject = new Map();
        waterwayDesignStations.forEach((station, index) => {
            if (station.reachId !== 'START' && station.reachId !== 'END' && waterwayStore.selectedWaterwayStations.includes(station.reachId)) {
                this.handleLiningMaterialChangeForReach(liningMaterialString, index, liningMaterialEditedStationObject);
            }
        });
        if (liningMaterialEditedStationObject.size > 0) {
            await this.props.addWDTEdits(liningMaterialEditedStationObject, true, true);
        }
    }


    @action.bound handleCloseLiningMaterialManualEntry() {
        this.isLiningMaterialPopupOpen = [false, ''];
    }


    @action.bound handleLiningMaterialChangeForReach(newMaterial: string, index: number, map: Map<string, IWaterwayVertexParamDTO>) {
        const waterwayDesignStations = this.currentObject.waterwayDesignStations;
        const reachId = waterwayDesignStations[index].reachId;
        if (waterwayDesignStations[index].capacity !== newMaterial) {
            waterwayDesignStations[index].capacity = newMaterial;
            waterwayDesignStations[index].stability = newMaterial;
            waterwayDesignStations[index].status = "IN PROGRESS";
            const liningMaterialEditedStationDTO: IWaterwayVertexParamDTO = convertStationBasedOnWaterwayVertexParamDTO(waterwayDesignStations[index], waterwayStore.channelControl);
            map.set(reachId, liningMaterialEditedStationDTO);
        }
    }

    @action.bound async checkAndApplyLiningMaterialChanges() {
        const newMaterial = waterwayStore.defaultLiningMaterial;
        await this.updateAllReachesLiningMaterial(newMaterial);
        // await MessageCenter.addNotificationFromCode("WDT_156");
    }

    // delete waterwayDesign station -->
    @observable deleteStationDialogIsOpen: boolean = false;
    @observable waterwayDesignStationToDelete: any = {};

    // ai experimental code
    @observable openAiDesignPanel = false;

    @action.bound async setWaterwayDesignStationToDelete(e: any, item: any) {
        e.preventDefault();
        this.waterwayDesignStationToDelete.reachId = item.reachId ? item.reachId : 'R-0';
        waterwayStore.deleteStationFromTable = true;
        this.toggleDeleteStationDialog();
    }

    @action.bound toggleDeleteStationDialog() {
        this.deleteStationDialogIsOpen = !this.deleteStationDialogIsOpen;
    }

    @action.bound async deleteWaterwayDesignStation() {
        if (this.waterwayDesignStationToDelete.reachId.substring(0, 1) == 'R' && this.currentObject.waterwayDesignStations.length > 4) {
            const stations = [{ ...waterwayStore.initialWaterwayDesignStation }]
            this.currentObject.waterwayDesignStations.forEach((station) => {
                stations.push(station);
            });
            stations.splice(0, 1);
            const indexToDelete = stations.findIndex(
                (s) => s.reachId === this.waterwayDesignStationToDelete.reachId
            );
            const editedWaterwayVertexData = new Map();
            const wvparam = stations[indexToDelete];
            wvparam.reachId = 'Delete'

            const deleteStationDTO: IWaterwayVertexParamDTO = convertStationBasedOnWaterwayVertexParamDTO(wvparam, waterwayStore.channelControl)
            editedWaterwayVertexData.set(this.waterwayDesignStationToDelete.reachId, deleteStationDTO)

            stations.splice(indexToDelete, 1);
            if (indexToDelete == 1) {          // Delete first reach station
                stations.forEach((station, idx) => {
                    const originalReachId = station.reachId;
                    if (idx == 1) {
                        station.reachId = 'R-0';
                        station.startStation = '-';
                        station.stationLength = 0.0;
                        station.grade = 0.0;
                    } else if (idx > 1 && idx < stations.length - 1) {
                        station.reachId = 'R-' + (Number(station.reachId.substring(2)) - 1);
                    }

                    const deleteStationDTO: IWaterwayVertexParamDTO = convertStationBasedOnWaterwayVertexParamDTO(station, waterwayStore.channelControl)
                    editedWaterwayVertexData.set(originalReachId, deleteStationDTO)
                });
            } else if (indexToDelete == stations.length - 1) {
                // Delete last reach station
                // Update END
                if (waterwayStore.waterwayDesignObject.endGradeLength > 0) {
                    const updatedEnd = await this.tableStore.calculateNewStartOrEndReach(stations.length - 1, stations);
                    const updatedEndStationDTO: IWaterwayVertexParamDTO = convertStationBasedOnWaterwayVertexParamDTO(updatedEnd, waterwayStore.channelControl)
                    editedWaterwayVertexData.set('END', updatedEndStationDTO);
                }
            } else if (indexToDelete > 1 && indexToDelete < stations.length - 1) {
                stations[indexToDelete].startStation = stations[indexToDelete - 1].endStation;
                stations[indexToDelete].stationLength = parseFloat((Number(stations[indexToDelete].endStation.replace("+", "")) - Number(stations[indexToDelete].startStation.replace("+", ""))).toFixed(1));
                stations[indexToDelete].grade = Math.abs((stations[indexToDelete].channelZ - stations[indexToDelete - 1].channelZ) / stations[indexToDelete].stationLength);
                let i = indexToDelete;
                for (i; i < stations.length - 1; i++) {
                    const originalReachId = stations[i].reachId;
                    stations[i].reachId = 'R-' + (Number(stations[i].reachId.substring(2)) - 1);
                    stations[i].status = 'IN PROGRESS';

                    const deleteStationDTO: IWaterwayVertexParamDTO = convertStationBasedOnWaterwayVertexParamDTO(stations[i], waterwayStore.channelControl)
                    editedWaterwayVertexData.set(originalReachId, deleteStationDTO)
                }
            }
            await this.props.addWDTEdits(editedWaterwayVertexData, false, true);
            this.currentObject.waterwayDesignStations.length = 0;
            this.currentObject.waterwayDesignStations = stations;
            await this.profileStore.deleteReachVertex({ index: indexToDelete - 1 }); // -1 for START station
            this.waterwayDesignStationToDelete.reachId = '';
            this.toggleDeleteStationDialog();
            if (waterwayStore.deleteStationFromTable) {
                waterwayStore.deleteStationFromTable = false;
                this.profileStore.createReachLineFromSavedWaterway();
            } else {
                this.profileStore.addCenterReachLabels(stations);
            }
        } else {
            this.waterwayDesignStationToDelete.reachId = '';
            this.toggleDeleteStationDialog();
        }

        // Stop editing if there are no more eligible stations to delete
        if (!this.deleteStationButtonStatus) {
            this.stopEditingMode();
        }
    }

    @action.bound moveVertex(e: any) {
        e.preventDefault();
        waterwayStore.selectedWaterwayStations = [];
        this.profileStore.unTrackProfilePoints();
        this.startEditingMode();
        this.profileStore.reshapePolyline(this.props.addWDTEdits);
    }

    private startEditingMode() {
        this.startEditing = true;
        const profileBtns = document.getElementById('waterway-design-profile-btns');
        const header = document.getElementsByClassName('profile-reaches-info');
        const btns = document.getElementById('waterway-design-btns');
        this.watchEditingHandle1 = profileBtns?.addEventListener('click', this.handleEditingClick.bind(this));
        this.watchEditingHandle2 = header[0]?.addEventListener('click', this.handleEditingClick.bind(this));
        this.watchEditingHandle3 = btns?.addEventListener('click', this.handleEditingClick.bind(this));
    }

    private stopEditingMode() {
        this.profileStore.stopEditing();
        this.watchEditingHandle1?.remove();
        this.watchEditingHandle2?.remove();
        this.watchEditingHandle3?.remove();
        this.startEditing = false;
    }

    private handleEditingClick() {
        if (this.startEditing) {
            this.stopEditingMode();
        }
    }

    @action.bound stopEditing(e: any) {
        e.preventDefault();
        this.stopEditingMode();
    }

    @action.bound deleteVertex(e: any) {
        e.preventDefault();
        waterwayStore.selectedWaterwayStations = [];
        this.profileStore.unTrackProfilePoints();
        this.startEditingMode();
        this.profileStore.deletePoint();
    }

    @action.bound async insertStationTableView(e: any, item: any) {
        const stations = this.currentObject.waterwayDesignStations;
        const originalStations = JSON.parse(JSON.stringify(stations));

        // Find the index of the item with the same reachId
        const index = stations.findIndex(station => station.reachId === item.reachId);

        // Create a deep copy of the item
        const newItem = JSON.parse(JSON.stringify(item));
        newItem.startStation = stations[index].endStation;


        // Above the added station
        if (index > 0) {
            // Remove '+' sign from endStation and startStation
            const startStation = parseFloat(stations[index].startStation.replace('+', ''));
            const endStation = parseFloat(stations[index].endStation.replace('+', ''));

            // Calculate the average point of endStation and startStation
            stations[index].station = formatStationString(((startStation + endStation) / 2.0).toFixed(1).toString());
            newItem.startStation = stations[index].station;

            // Calculate the average point of channelZ and the channelZ of the station above it
            const currentChannelZ = parseFloat(stations[index].channelZ);
            const prevChannelZ = parseFloat(stations[index - 1].channelZ);
            stations[index].channelZ = (((currentChannelZ + prevChannelZ) / 2).toFixed(1)).toString();
            stations[index].endStation = stations[index].station;
            stations[index].channelElev = stations[index].channelZ;
            stations[index].status = "IN PROGRESS";
            stations[index].addedQ = "";
            stations[index].flowDepthFB = "";
            stations[index].flowTopWidth = "";

            // Calculate groundZ for the current index
            const payload = {
                alignedElementDesignParametersId: this.currentObject.alignedElementDesignParametersId,
                reachStationDistance: parseFloat(stations[index].endStation) // new station x value
            };

            const response = await ProfileController.getGroundElevationByReachStationDistanceFromAlignmentUsingPOST(payload);
            if (response.data && response.data.groundElevation !== undefined) {
                stations[index].groundZ = parseFloat(response.data.groundElevation.toFixed(1));
                stations[index].cutFill = parseFloat((parseFloat(stations[index].channelZ) - stations[index].groundZ).toFixed(1));
            }

            // Calculate stationLength and grade for the current index
            const prevStation = stations[index - 1];

            if (prevStation && prevStation.reachId !== "START") {
                const deltaCurY = parseFloat(prevStation.channelZ) - parseFloat(stations[index].channelZ);
                const deltaCurX = parseStationString(prevStation.station) - parseStationString(stations[index].station);
                stations[index].grade = Math.abs(deltaCurY / deltaCurX);
                stations[index].stationLength = Math.abs(deltaCurX).toFixed(1);
            }
        }

        // Leave output parameters empty
        newItem.status = "IN PROGRESS";
        newItem.runoffQ = stations[index].totalQ;
        newItem.addedQ = "";
        newItem.flowDepthFB = "";
        newItem.flowTopWidth = "";



        // Calculate groundZ for the new item
        const payload = {
            alignedElementDesignParametersId: this.currentObject.alignedElementDesignParametersId,
            reachStationDistance: parseFloat(newItem.endStation) //new station x value
        };

        const response = await ProfileController.getGroundElevationByReachStationDistanceFromAlignmentUsingPOST(payload);
        if (response.data && response.data.groundElevation !== undefined) {

            newItem.groundZ = parseFloat(response.data.groundElevation.toFixed(1));
            newItem.cutFill = parseFloat((parseFloat(newItem.channelZ) - newItem.groundZ).toFixed(1));
        }

        // Calculate stationLength and grade for the new item
        const prevStation = stations[index];
        if (prevStation && prevStation.reachId !== "START") {
            const deltaCurY = parseFloat(prevStation.channelZ) - parseFloat(newItem.channelZ);
            const deltaCurX = parseStationString(prevStation.station) - parseStationString(newItem.station);

            newItem.grade = Math.abs(deltaCurY / deltaCurX);
            newItem.stationLength = Math.abs(deltaCurX).toFixed(1);
        }


        // Insert the new item at the next index
        stations.splice(index + 1, 0, newItem);

        // Create the array to hold the updated stations
        const stationsInsertedAndUpdated: any = [];

        // Add the current index item to the array
        stationsInsertedAndUpdated.push(stations[index]);

        // Update the reachId of the new item and all subsequent items
        for (let i = index + 1; i < stations.length; i++) {
            if (stations[i].reachId !== "END" && stations[i].reachId !== "START" && stations[i].reachId !== "R-0") {
                const reachIdNumber = parseInt(stations[i].reachId.split('-')[1]);
                stations[i].reachId = `R-${reachIdNumber + 1}`;
                stations[i].status = 'IN PROGRESS'
                // Add the updated station to the array
                stationsInsertedAndUpdated.push(stations[i]);
            }
        }

        // Create a new Map to hold all the updated values
        const allUpdatedValues = new Map();
        this.profileStore.addReachVertex({ index: index - 1, item: stations[index] });
        // Compare original and updated stations to find the stations that were added
        stationsInsertedAndUpdated.forEach((updatedStation, index) => {
            if (!updatedStation.station || !updatedStation.channelZ) {
                return;
            }

            const updatedStationDTO: IWaterwayVertexParamDTO = convertStationBasedOnWaterwayVertexParamDTO(updatedStation, waterwayStore.channelControl)
            const originalStation = originalStations.find(os => os.station === updatedStationDTO.endStation && parseFloat(os.channelZ) === updatedStationDTO.channelElev);
            if (!originalStation) {
                allUpdatedValues.set("Add", updatedStationDTO);
            } else if (originalStation.reachId !== updatedStationDTO.reachId) {
                allUpdatedValues.set(originalStation.reachId, updatedStationDTO);
            }
        });

        // Send all the updated values at once
        const validationErrorOccurred = await WaterwayDesignVM.stationFieldValidation(stations);
        this.profileStore.addCenterReachLabels(stations);
        if (!validationErrorOccurred) {
            waterwayStore.waterwayDesignObject.waterwayDesignStations = stations;
            await this.props.addWDTEdits(allUpdatedValues, false, true);
        }
    }
    public static async stationFieldValidation(stations) {
        const fieldsToCheck = ['startStation', 'endStation', 'station', 'groundZ', 'channelZ', 'cutFill', 'stationLength', 'grade'];
        const fieldDisplayNames = {
            'startStation': 'Start Station',
            'endStation': 'End Station',
            'station': 'Station',
            'groundZ': 'Ground Z',
            'channelZ': 'Channel Z',
            'cutFill': 'Cut Fill',
            'stationLength': 'Station Length',
            'grade': 'Grade'
        };
        let direction: number | null = null;
        let errorOccurred = false;

        // Create a copy of stations for validation
        const validationStations = JSON.parse(JSON.stringify(stations));
        // Calculate slope for each station for validation
        for (let i = 1; i < validationStations.length; i++) {
            const prevStation = validationStations[i - 1];
            if (prevStation && prevStation.station && validationStations[i].station && !['START', 'R-0', 'END'].includes(validationStations[i].reachId)) {
                const deltaCurY = parseFloat(prevStation.channelZ) - parseFloat(validationStations[i].channelZ);
                if (prevStation.station && validationStations[i].station) {
                    const deltaCurX = (parseFloat(prevStation.station.split('+')[0]) * 100 + parseFloat(prevStation.station.split('+')[1])) -
                        (parseFloat(validationStations[i].station.split('+')[0]) * 100 + parseFloat(validationStations[i].station.split('+')[1]));
                    if (deltaCurX !== 0) {
                        validationStations[i].grade = (deltaCurY / deltaCurX);
                        validationStations[i].stationLength = Math.abs(deltaCurX).toFixed(1);

                        // Skip if grade is 0
                        if (validationStations[i].grade === 0.0) {
                            continue;
                        }

                        // Determine the direction of the first non-zero grade
                        if (direction === null) {
                            direction = Math.sign(validationStations[i].grade);
                        }

                        // Check if the direction of the current grade matches the determined direction
                        if (Math.sign(validationStations[i].grade) !== direction) {
                            await MessageCenter.addErrorFromCode('WDT_69');
                            errorOccurred = true;
                            break;
                        }
                    }
                }
                if (errorOccurred) {
                    break;
                }
            }
        }

        if (!errorOccurred) {
            for (const station of stations) {
                // Don't check for reachIDs 'START', 'R-0' and 'END'
                if (['START', 'R-0', 'END'].includes(station.reachId)) {
                    continue;
                }

                for (const field of fieldsToCheck) {
                    if (!station[field] || station[field] === '-') {
                        await MessageCenter.addNotificationFromCode('Common_17', undefined, fieldDisplayNames[field]);
                        errorOccurred = true;
                        break;
                    }
                }
                if (errorOccurred) {
                    break;
                }
            }

            return errorOccurred;
        }
    }

    formatStation(data: string) {
        const splitedArray = data.split('+');
        const hundreds = parseInt(splitedArray[0]);
        const tens = Number(splitedArray[1]);
        return hundreds.toString() + '+' + tens.toLocaleString('en', { minimumIntegerDigits: 2, minimumFractionDigits: 1 })
    }


    @action.bound async getUiStateAndNotification() {
        await this.props.getNotificationStatus();
        await this.props.getDesignUiState();
    }

    @action.bound async applyDefaultLiningMaterialChange() {
        const newMaterial = waterwayStore.defaultLiningMaterial;
        if (newMaterial) {
            const editedStations = this.currentObject.waterwayDesignStations.map(station => {
                if (station.reachId !== 'START' && station.reachId !== 'END' && station.reachId !== 'R-0') {
                    station.capacity = newMaterial;
                    station.stability = newMaterial;
                }
                return station;
            });

            const editedWaterwayVertexData = new Map();
            editedStations.forEach(station => {
                const vertexDTO: IWaterwayVertexParamDTO = convertStationBasedOnWaterwayVertexParamDTO(station, waterwayStore.channelControl);
                editedWaterwayVertexData.set(station.reachId, vertexDTO);
            });

            await this.props.addWDTEdits(editedWaterwayVertexData, false, true);

            this.currentObject.waterwayDesignStations = editedStations;
        }
    }

    @action.bound async saveWaterwayDesign(savingType: 'save' | 'saveAndCalculate') {
        // call saveReachEdits() function in SurfaceDesignerVM --> call API WaterwayDesignToolsReachJsonController.saveReachEditsUsingPOST
        this.stopEditingMode();
        designStore.setLoader('Saving Pending Edits...');
        if (await this.props.saveReachEdits()) {
            this.storedWaterwayStations = undefined;
            if (savingType === 'save') {
                await this.saveUiState('save')
                await this.getUiStateAndNotification();
            }
            else if (savingType === 'saveAndCalculate') {
                designStore.setLoader('Calculating Waterway...');
                // recalculate reach table --> API call
                try {
                    const calculateResponse = await WaterwayDesignToolsController.waterwaySimulationAndValidationUsingPOST(this.currentObject.alignedElementDesignParametersId);
                    if (calculateResponse && calculateResponse.data && !calculateResponse.data.validationPass && calculateResponse.data.errMessage) {
                        const errorCode = calculateResponse.data.errCode;
                        const errMessage = calculateResponse.data.errMessage;

                        //Handle multiple error codes
                        // if (errorCode === 'WDT_112' && errMessage.includes('deflection')) {
                        //     const alignmentIndex = errMessage.indexOf('Alignment');
                        //     const beforeAlignmentText = errMessage.substring(0, alignmentIndex).trim();
                        //     await MessageCenter.addNotificationFromCode('WDT_112', undefined, beforeAlignmentText);
                        // } else 
                        await this.callWaterwayError(errorCode, errMessage);

                        await this.getAllWaterwayVertex();
                    }

                    if (calculateResponse && calculateResponse.data && calculateResponse.data.validationPass) {
                        try {
                            // 1. Call https://eft-set.spatialfrontlab.com/set/waterwaydesign/channelStructureCalculation
                            const channelStructureCalculationResponse = await WaterwayDesignToolsController.channelStructureCalculationUsingPOST(this.currentObject.alignedElementDesignParametersId);
                            const channelStructureCalculationData = channelStructureCalculationResponse.data;
                            if (channelStructureCalculationData.status === null) { // status === null means the calculation is successful, otherwise returns error code
                                await this.saveUiState('save&Calculate');
                                await this.getUiStateAndNotification();
                                await this.generateWWSurfaceAndShape('save&Calculate');
                                await this.getWaterwaySummaryBannerReportObj();
                            }
                            else {
                                await MessageCenter.addNotificationFromCode(channelStructureCalculationData.status!)
                            }
                            // 2. Call https://eft-set.spatialfrontlab.com/set/waterwaydesign/getAlignedElementShapeByAlignedElementId
                            await this.getAllWaterwayVertex();
                        }
                        catch (err) {
                            console.error('error: getAllWaterwayVertexDtoByAlignedElementDesignParametersIdUsingGET() exportResult is undefined or some other errors', err);
                        }
                        await this.getWaterwaySummaryBannerReportObj()

                        // Clone object after Save & Calculate
                        waterwayStore.wdtGroupsOriginals = [];
                        waterwayStore.wdtGroupsOriginals.push(
                            {
                                groupCount: 0,
                                currentObject: JSON.parse(JSON.stringify(waterwayStore.waterwayDesignObject))
                            }
                        );
                    }
                } catch (err) {
                    MessageCenter.addError((err as Error).message);
                }
            }
            await waterwayStore.defaultLiningMaterialChange();
            designStore.setLoader('');
        }
        designStore.setLoader('');
    }

    private async getAllWaterwayVertex() {
        const response = await WaterwayDesignToolsReachJsonController.getAllWaterwayVertexDtoByAlignedElementDesignParametersIdUsingGET(this.currentObject.alignedElementDesignParametersId);
        if (response && response.data) {
            const recalculationData = response.data;
            // order the response array and put the END to the end of the array
            // recalculationData.push(recalculationData.splice(1, 1)[0]);
            stores.AppStore.waterwayDesignStore.waterwayDesignObject.waterwayDesignStations.forEach((waterwayDesignStation, index) => {
                const newStation = recalculationData[index];
                // initilize waterwayDesignStation.channelParams if it is undefined
                waterwayDesignStation.channelParams = {
                    startSlopeDistance: waterwayDesignStation.channelParams ? (waterwayDesignStation.channelParams.startSlopeDistance ? waterwayDesignStation.channelParams.startSlopeDistance : 0.0) : 0.0,
                    bermWidth: waterwayDesignStation.channelParams ? (waterwayDesignStation.channelParams.bermWidth ? waterwayDesignStation.channelParams.bermWidth : 0.0) : 0.0,
                    leftSlopeRatio: waterwayDesignStation.channelParams ? (waterwayDesignStation.channelParams.leftSlopeRatio ? waterwayDesignStation.channelParams.leftSlopeRatio : 0.0) : 0.0,
                    dipDepth: waterwayDesignStation.channelParams ? (waterwayDesignStation.channelParams.dipDepth ? waterwayDesignStation.channelParams.dipDepth : 0.0) : 0.0,
                    offset2: waterwayDesignStation.channelParams ? (waterwayDesignStation.channelParams.offset2 ? waterwayDesignStation.channelParams.offset2 : 0.0) : 0.0,
                    sideWidthLimit: waterwayDesignStation.channelParams ? (waterwayDesignStation.channelParams.sideWidthLimit ? waterwayDesignStation.channelParams.sideWidthLimit : 0.0) : 0.0,
                    offset1: waterwayDesignStation.channelParams ? (waterwayDesignStation.channelParams.offset1 ? waterwayDesignStation.channelParams.offset1 : 0.0) : 0.0,
                    backSlopeRatio: waterwayDesignStation.channelParams ? (waterwayDesignStation.channelParams.backSlopeRatio ? waterwayDesignStation.channelParams.backSlopeRatio : 0.0) : 0.0,
                    sideSlope: waterwayDesignStation.channelParams ? (waterwayDesignStation.channelParams.sideSlope ? waterwayDesignStation.channelParams.sideSlope : 0.0) : 0.0,
                    freeBoard: waterwayDesignStation.channelParams ? (waterwayDesignStation.channelParams.freeBoard ? waterwayDesignStation.channelParams.freeBoard : 0.0) : 0.0,
                    offset3: waterwayDesignStation.channelParams ? (waterwayDesignStation.channelParams.offset3 ? waterwayDesignStation.channelParams.offset3 : 0.0) : 0.0,
                    rightSlopeRatio: waterwayDesignStation.channelParams ? (waterwayDesignStation.channelParams.rightSlopeRatio ? waterwayDesignStation.channelParams.rightSlopeRatio : 0.0) : 0.0,
                    minBedWidth: waterwayDesignStation.channelParams ? (waterwayDesignStation.channelParams.minBedWidth ? waterwayDesignStation.channelParams.minBedWidth : 0.0) : 0.0,
                    endSlopeDistance: waterwayDesignStation.channelParams ? (waterwayDesignStation.channelParams.endSlopeDistance ? waterwayDesignStation.channelParams.endSlopeDistance : 0.0) : 0.0,
                };

                //populate updated date to reach table, update waterwayDesignStore
                waterwayDesignStation.channelShapeType = waterwayStore.channelControl;
                waterwayDesignStation.status = newStation.status ? newStation.status : '';
                waterwayDesignStation.reachId = newStation.reachId ? newStation.reachId : '';
                waterwayDesignStation.startStation = newStation.startStation ? this.formatStation(newStation.startStation) : '';
                waterwayDesignStation.endStation = newStation.endStation ? this.formatStation(newStation.endStation) : '';
                waterwayDesignStation.station = newStation.endStation ? this.formatStation(newStation.endStation) : '';
                waterwayDesignStation.groundZ = toDecimalPrecision(Number(newStation.groundElev), 1);
                waterwayDesignStation.channelZ = toDecimalPrecision(Number(newStation.channelElev), 1);
                waterwayDesignStation.cutFill = toDecimalPrecision(Number(newStation.cutFill), 1);
                waterwayDesignStation.stationLength = toDecimalPrecision(Number(newStation.stationDist), 1);
                waterwayDesignStation.grade = newStation.grade ? newStation.grade : 0.0;
                waterwayDesignStation.channelParams.leftSlopeRatio = newStation.channelParams ? (newStation.channelParams.leftSlopeRatio ? toDecimalPrecision(Number(newStation.channelParams.leftSlopeRatio), 0) : 0.0) : 0.0;
                waterwayDesignStation.channelParams.rightSlopeRatio = newStation.channelParams ? (newStation.channelParams.rightSlopeRatio ? toDecimalPrecision(Number(newStation.channelParams.rightSlopeRatio), 0) : 0.0) : 0.0;
                waterwayDesignStation.channelParams.bermWidth = newStation.channelParams ? (newStation.channelParams.bermWidth ? toDecimalPrecision(Number(newStation.channelParams.bermWidth), 0) : 0.0) : 0.0;
                waterwayDesignStation.channelParams.offset1 = newStation.channelParams ? (newStation.channelParams.offset1 ? toDecimalPrecision(Number(newStation.channelParams.offset1), 0) : 0.0) : 0.0;
                waterwayDesignStation.channelParams.offset2 = newStation.channelParams ? (newStation.channelParams.offset2 ? toDecimalPrecision(Number(newStation.channelParams.offset2), 0) : 0.0) : 0.0;
                waterwayDesignStation.channelParams.offset3 = newStation.channelParams ? (newStation.channelParams.offset3 ? toDecimalPrecision(Number(newStation.channelParams.offset3), 0) : 0.0) : 0.0;
                waterwayDesignStation.runoffQ = toDecimalPrecision(Number(newStation.simFlowQ), 1);
                waterwayDesignStation.addedQ = toDecimalPrecision(Number(newStation.addedQ), 1);
                waterwayDesignStation.totalQ = toDecimalPrecision(Number(newStation.totalQ), 1);
                waterwayDesignStation.flowDepthFB = toDecimalPrecision(Number(newStation.simDepth), 2);
                waterwayDesignStation.flowTopWidth = toDecimalPrecision(Number(newStation.simWidth), 2);
                waterwayDesignStation.stabVelocity = toDecimalPrecision(Number(newStation.stabVelocity), 1);
                waterwayDesignStation.capaVelocity = toDecimalPrecision(Number(newStation.capaVelocity), 1);
                waterwayDesignStation.soilStrength = newStation.soilStrength ? newStation.soilStrength : '';
                waterwayDesignStation.vegCover = newStation.vegetalCover ? newStation.vegetalCover : '';
                waterwayDesignStation.stability = newStation.stability ? newStation.stability : '';
                waterwayDesignStation.capacity = newStation.capacity ? newStation.capacity : '';
                waterwayDesignStation.error = newStation.errorCode ? newStation.errorCode : '';
            })
        }
    }

    @action.bound async getWaterwaySummaryBannerReportObj() {
        try {
            // calling waterwayresultssummary API only when waterwaySimulationAndValidation API is Warning or Passed!
            const resultsValues = await WaterwayDesignToolsController.getWaterwaySummaryResultsUsingGET(this.currentObject.alignedElementDesignParametersId);
            if (resultsValues.data) {
                waterwayStore.waterwaySummaryBannerReportObj = resultsValues.data;
                designStore.displayResultBanner = true;
            }
        } catch (err) {
            console.error('error: getWaterwaySummaryResults()', err)
        }
    }

    @action.bound async getWaterwaySummaryReport() {
        try {
            if (waterwayStore?.waterwaySummaryBannerReportObj?.waterWayType === "Grassed Waterway") {
                const reportValues = await WaterwayDesignToolsController.getWaterwaySummaryReportByAlignedElementDesignParamsIdUsingGET(this.currentObject.alignedElementDesignParametersId);
                this.waterwaySummaryReportObj = reportValues.data;
            } else {
                const reportValues = await WaterwayDesignToolsController.getWaterwaySummaryReportUsingGET(this.currentObject.alignedElementDesignParametersId);
                this.waterwaySummaryReportObj = reportValues.data;
            }
        } catch (err) {
            console.error('error: getWaterwaySummaryReport()', err)
        }
    }

    @action.bound async generateWWSurfaceAndShape(callFrom) {
        let errorCode = "WDT_81";
        try {
            if (!(this.currentObject && this.currentObject.alignedElementDesignParametersId)) {
                throw new Error("Invalid state: no current waterway design ID.");
            }
            const surfaceText = (callFrom === 'generateSurface' ? "surface and " : "");
            designStore.setLoader(`Loading ${surfaceText}channel shape...`);
            const wwDesignId = this.currentObject.alignedElementDesignParametersId;
            let channelResult: any;
            let turnOnTin: boolean = false;
            if (callFrom === 'generateSurface') {
                const response = await WaterwayDesignToolsController.generateWaterwayDesignSurfaceByAlignedElementIdUsingGET(wwDesignId);
                if (response && response.data && response.data.alignedStructureShapeDTO) {
                    if (response.data.alignedStructureShapeDTO["status"]) {
                        errorCode = response.data.alignedStructureShapeDTO["status"];
                        throw new Error("Failed to generate channel data from the service.");
                    }
                    else {
                        channelResult = response.data;
                        await this.saveUiState("generateSurface");
                        await this.getUiStateAndNotification();
                        if ((!channelResult.contourLines || channelResult.contourLines.length === 0) && channelResult.tinTriangles) {
                            MessageCenter.addWarningFromCode('WDT_133');
                            turnOnTin = true;
                        }
                    }
                }
                else {
                    throw new Error("Failed to generate channel data from the service.");
                }
            }
            if (callFrom === 'save&Calculate') {
                const response = await WaterwayDesignToolsController.getAlignedElementShapeByAlignedElementIdUsingGET(wwDesignId);
                if (response && response.data && response.data.alignedFeatureDesignShapeJson) {
                    channelResult = JSON.parse(response.data.alignedFeatureDesignShapeJson);
                    if (!channelResult.alignedStructureShapeDTO) {
                        throw new Error("Failed to retrieve channel data from the service.");
                    }
                } else {
                    throw new Error("Failed to retrieve channel data from the service.");
                }
            }

            // console.warn(waterwayStore.uiState);
            // console.warn(channelResult);

            if ((waterwayStore.uiState === 'ReachDesignSurface') &&
                (channelResult.tinTriangles || channelResult.contourLines)) {
                await DesignContainerVM.loadSurfaceFromData(
                    channelResult.tinTriangles,
                    undefined,
                    channelResult.contourLines,
                    undefined,
                    undefined,
                    true
                );
                if (turnOnTin && this.mapView) {
                    const DesignedTinTrianglesLayer = this.mapView.map.findLayerById(AppConstants.DesignedTinTrianglesLayerId) as GraphicsLayer;
                    if (DesignedTinTrianglesLayer) {
                        DesignedTinTrianglesLayer.visible = true;
                    }
                }
            }

            if (this.mapView) {
                if (callFrom === 'save&Calculate') {
                    await DesignContainerVM.loadOriginalSurface();
                    const SurveyPointsLayer = this.mapView.map.findLayerById(AppConstants.SurveyPointsLayerId) as GraphicsLayer;
                    if (SurveyPointsLayer) {
                        SurveyPointsLayer.visible = false;
                    }
                }
                waterwayStore.addWaterwayToMap(
                    channelResult.alignedStructureShapeDTO,
                    this.mapView,
                    wwDesignId.toString(),
                    waterwayStore.alignedFeatureName
                );
                await this.takeWaterwayScreenshot(wwDesignId);
                if (!designStore.hideSingleCrossSection) {
                    designStore.validateSingleCrossSection(this.mapView, 'CS_3');
                }
            }
        } catch (e) {
            // console.error((e as Error).message);
            await MessageCenter.addErrorFromCode(errorCode, [
                {
                    callback: () => {
                        MessageCenter.clearMessages();
                    },
                    text: 'OK',
                },
            ]);
        } finally {
            designStore.setLoader("");
        }
    }

    private async takeWaterwayScreenshot(wwDesignId): Promise<void> {
        let hasError = false;
        try {
            let foundLayer = true;
            let wwBoundaryPolygon: GraphicsLayer | undefined = undefined;
            const wwLayer = this.mapView!.map.findLayerById('Waterway' + wwDesignId.toString());
            if (wwLayer) {
                const wwCombo = (wwLayer as GroupLayer).findLayerById('waterway_polygon');
                if (wwCombo) {
                    wwBoundaryPolygon = wwCombo as GraphicsLayer;
                    if (!wwBoundaryPolygon) {
                        foundLayer = false;
                    }
                } else {
                    foundLayer = false;
                }
                const seedingCombo = (wwLayer as GroupLayer).findLayerById('seeding_combo');
                if (seedingCombo) { // use seeding polygon if seeding combo exists
                    wwBoundaryPolygon = (seedingCombo as GroupLayer).findLayerById('seeding_polygon') as GraphicsLayer;
                    if (wwBoundaryPolygon) {
                        foundLayer = true;
                    }
                }
            } else {
                foundLayer = false;
            }
            if (foundLayer) {
                let borderPolygonsExtent: Extent | undefined = undefined;
                if (wwBoundaryPolygon && (wwBoundaryPolygon.graphics.length > 0)) {
                    borderPolygonsExtent = wwBoundaryPolygon.graphics.at(0).geometry.extent.clone();
                    borderPolygonsExtent.expand(1.1);
                    this.mapView!.goTo(borderPolygonsExtent);
                    await this.mapView!.when();
                    await sleep(5000);

                    const dimensions = getDimensionsForImage(borderPolygonsExtent, this.mapView);

                    const projectUuid = designStore.projectsStore.currentProjectId as string;
                    if (projectUuid) {
                        const screenshot = await this.mapView!.takeScreenshot({
                            width: dimensions.imageWidth,
                            height: dimensions.imageHeight,
                            area: dimensions.area,
                            format: 'png',
                            ignorePadding: true
                        });
                        if (screenshot) {
                            await saveScreenshot(projectUuid, screenshot.dataUrl);
                            // console.warn(screenshot.dataUrl);
                        } else {
                            hasError = true;
                        }
                    } else {
                        hasError = true;
                    }
                }
            } else {
                hasError = true;
            }
        } catch (e) {
            hasError = true;
        } finally {
            if (hasError) {
                await MessageCenter.addNotificationFromCode('Common_20', [
                    {
                        callback: () => {
                            MessageCenter.clearMessages();
                        },
                        text: 'OK',
                    },
                ]);
            }
        }
    }

    @action.bound handleCheckboxChange(e: any, i: number) {
        const station = this.currentObject.waterwayDesignStations[i];

        // this is not working
        // Prevent unchecking the initially selected reach
        // if (!e.target.checked && station.reachId === this.selectedWaterwayStationForWSC) {
        //     e.preventDefault();
        //     return;
        // }

        if (e.target.checked) {
            if (!waterwayStore.selectedWaterwayStations.includes(station.reachId)) {
                waterwayStore.selectedWaterwayStations.push(station.reachId);
            }
            if (station.reachId === 'R-1' && !waterwayStore.selectedWaterwayStations.includes("R-0")) {
                waterwayStore.selectedWaterwayStations.push("R-0");
            }
            // Only proceed with Point creation if station has necessary properties
            if (station.station && station.channelZ) {
                const stationX = designStore.commonHorizontalStretchFactor
                    ? (parseFloat(station.station.replace('+', '')) * designStore.commonHorizontalStretchFactor)
                    : parseFloat(station.station.replace('+', ''));
                const point = new Point({
                    x: stationX,
                    y: station.channelZ * (designStore.commonVerticalStretchFactor || AppConstants.profileStretchFactor),
                    spatialReference: this.profileStore._profileView?.spatialReference
                });
                this.profileStore.trackProfilePoint(point, station.reachId);
            }
        } else {
            waterwayStore.selectedWaterwayStations = waterwayStore.selectedWaterwayStations.filter((p) => {
                if (station.reachId === 'R-1') {
                    return (p !== station.reachId && p !== 'R-0');
                }
                else {
                    return p !== station.reachId;
                }
            });
            // this.profileStore.unTrackProfilePoint(station.reachId);
        }
        // this.waterwayInputVM.selectedLiningMaterialReaches = [...waterwayStore.selectedWaterwayStations];

        // waterwayStore.handleReachSelectionChange(station.reachId, e.target.checked);
        // waterwayStore.updateSelectedReachNames();
    }

    @action.bound handleRowMouseEnter(e: any, i: number) {
        this.trackTableRow(i, true);
    }

    @action.bound handleRowMouseLeave(e: any, i: number) {
        this.trackTableRow(i, false);
    }

    protected trackTableRow(i: number, onOff: boolean) {
        const station = this.currentObject.waterwayDesignStations[i];

        // Add check for undefined or null station
        if (!station) {
            console.error(`Station at index ${i} is undefined.`);
            return;
        }

        if (!waterwayStore.selectedWaterwayStations.some(e => e === station.reachId)) {
            if (onOff) {
                if (station.station && !(station.reachId === "START")) {
                    const stationX = designStore.commonHorizontalStretchFactor ? (parseFloat(station.station.replace('+', '')) * designStore.commonHorizontalStretchFactor) : parseFloat(station.station.replace('+', ''));
                    const point = new Point({
                        x: stationX,
                        y: station.channelZ * (designStore.commonVerticalStretchFactor || AppConstants.profileStretchFactor),
                        spatialReference: this.profileStore._profileView?.spatialReference
                    })
                    this.profileStore.trackProfilePoint(point, station.reachId);
                }
            } else {
                this.profileStore.unTrackProfilePoint(station.reachId);
            }
        }

        if (onOff && !(station.reachId === "START")) {
            if (this.profileStore.hub.MapStore) {
                (this.profileStore.hub.MapStore as DynamicWaterwayMapStore).trackStation(i);
            }
        } else {
            if (this.profileStore.hub.MapStore) {
                (this.profileStore.hub.MapStore as DynamicWaterwayMapStore).untrackStation(i);
            }
        }
    }

    @action.bound selectAll() {
        // If all stations are already selected, deselect all
        if (waterwayStore.selectedWaterwayStations.length === this.currentObject.waterwayDesignStations.length - 2) {
            waterwayStore.selectedWaterwayStations = [];
        } else {
            // Otherwise, select all stations
            const allStations: string[] = [];
            for (const station of this.currentObject.waterwayDesignStations) {
                if (station.reachId !== "START" && station.reachId !== "END") {
                    allStations.push(station.reachId);
                }
            }
            waterwayStore.selectedWaterwayStations = allStations;
        }
        this.profileStore.unTrackProfilePoints();
        for (const id of waterwayStore.selectedWaterwayStations) {
            const station = this.currentObject.waterwayDesignStations.find((station) => station.reachId === id);

            // Skip the station if its reachId is "START", "R-0", or "END"
            if (station.reachId === "START" || station.reachId === "END") {
                continue;
            }
            if (station.station != '-') {
                const stationX = designStore.commonHorizontalStretchFactor ? (parseFloat(station.station.replace('+', '')) * designStore.commonHorizontalStretchFactor) : parseFloat(station.station.replace('+', ''));
                const point = new Point({
                    x: stationX,
                    y: station.channelZ * (designStore.commonVerticalStretchFactor || AppConstants.profileStretchFactor),
                    spatialReference: this.profileStore._profileView?.spatialReference
                })
                this.profileStore.trackProfilePoint(point, station.reachId);
            }
        }

    }

    @action.bound async handleInputChange(event: any, index) {
        const { value, name } = event.target;
        const waterwayDesignStations = this.currentObject.waterwayDesignStations;
        waterwayDesignStations[index][name] = value;
        this.changedInputValue = true;
        this.isEnableSaveCalculate = false;
        waterwayDesignStations[index].status = "IN PROGRESS";
        this.validateFieldReachTable(name, value, index);
        if (name === 'grade' && value === '') {
            waterwayStore.startGradeNegative = false;
            waterwayStore.endGradeNegative = false;
        }
    }

    @action.bound async validateFieldReachTable(fieldName, value, index) {
        // Connects form fields to validation reach table
        const keyValid = fieldName + 'Valid';
        let fieldValid = this.formValidationReachTable[keyValid];
        const fieldValidationErrors = this.formValidationReachTable.formErrors;
        let errorCode: string = '';
        // Disallow negative numbers, letters, and '+' character for specified fields
        if (
            (
                (fieldName !== 'station' && fieldName !== 'addedQ' && fieldName !== 'grade') &&
                (!testDecimalString(value))
            ) ||
            (
                (fieldName === 'station') &&
                (!testStationString(value))
            ) ||
            (
                (fieldName === 'addedQ') &&
                (!testDecimalString(value, true))
            )
        ) {
            // If the input is invalid, show an error message and set isError to true
            if (fieldName === 'leftSS' && this.currentObject.waterwayDesignStations[index].channelShapeType === 'PARABOLIC') {
                errorCode = 'WDT_36';
            } else if (fieldName === 'leftSS' || fieldName === 'rightSS') {
                errorCode = 'WDT_42';
            } else if (fieldName === 'offset1' || fieldName === 'offset2' || fieldName === 'offset3') {
                errorCode = 'WDT_18';
            } else if (fieldName === 'flowDepthFB' || fieldName === 'flowTopWidth') {
                errorCode = 'Common_10';
            } else if (fieldName === 'bottomWidth') {
                errorCode = 'WDT_43';
            } else if (fieldName === 'station') {
                errorCode = 'WDT_101';
            } else if (fieldName === 'channelZ') {
                errorCode = 'Common_10';
            } else if (fieldName === 'stationLength') {
                errorCode = 'Common_10';
            } else if (fieldName === 'addedQ') {
                errorCode = 'Common_21';
            }
            fieldValid = false;
        } else {
            fieldValid = true;
        }

        this.formValidationReachTable.formErrors = fieldValidationErrors;
        await this.getErrorMessage(errorCode, this.formValidationReachTable.formErrors, fieldName);
        this.formValidationReachTable[keyValid] = fieldValid;

        if (!fieldValid) {
            this.formValidationReachTable.invalidFields.push({
                fieldName,
                index
            });

        } else {
            this.formValidationReachTable.invalidFields = this.formValidationReachTable.invalidFields.filter(
                field => !(field.fieldName === fieldName && field.index === index)
            );
        }

        this.validateFormReachTable();
    }

    @action.bound async getErrorMessage(code: string, container, fieldName: string) {
        if (code === '') {
            container[fieldName] = '';
        } else {
            const field = code === 'Common_10' ? fieldName.charAt(0).toUpperCase() + fieldName.slice(1) : undefined;
            await MessageCenter.addNotificationFromCode(code, undefined, field);
        }
    }


    @action.bound validateFormReachTable() {
        let valid = true;
        for (const key in this.formValidationReachTable.formErrors) {
            if (key === 'channelParams') {
                for (const subKey in this.formValidationReachTable.formErrors[key]) {
                    if (!this.formValidationReachTable.channelParamsValid[subKey + 'Valid']) {
                        valid = false;
                        break;
                    }
                }
            } else if (!this.formValidationReachTable[key + 'Valid']) {
                valid = false;
            }
            if (!valid) {
                break;
            }
        }
        this.formValidationReachTable.formValid = valid;
    }

    @action.bound onClickInformationToggle = (title) => {
        this.headerTitle = title
        this.onClickInformation = !this.onClickInformation
    }

    @action.bound async confirmFlowDepthWidthEdit(name: string, value: any, index) {
        if ((name === 'flowDepthFB' && this.currentObject.waterwayDesignStations[index].widthEdited) ||
            (name === 'flowTopWidth' && this.currentObject.waterwayDesignStations[index].depthEdited)) {
            await MessageCenter.addNotificationFromCode('WDT_118', [
                {
                    callback: () => {
                        MessageCenter.clearMessages();
                        if (name === 'flowDepthFB') {
                            this.currentObject.waterwayDesignStations[index].flowDepthFB = this.previousFlowDepthFB;
                        } else if (name === 'flowTopWidth') {
                            this.currentObject.waterwayDesignStations[index].flowTopWidth = this.previousFlowTopWidth;
                        }
                    },
                    text: 'Cancel',
                },
                {
                    callback: () => {
                        MessageCenter.clearMessages();
                        this.handleFlowDepthWidthChange(name, value, index);
                    },
                    text: 'OK',
                },
            ], name === 'flowDepthFB' ? 'Flow Top Width' : 'Flow Depth + FB');
        } else {
            this.handleFlowDepthWidthChange(name, value, index);
        }
    }

    @action.bound async handleFlowDepthWidthChange(name: string, value: any, index, map?) {
        const waterwayDesignStations = this.currentObject.waterwayDesignStations;
        const reachId = waterwayDesignStations[index].reachId;
        if (name === 'flowDepthFB') {
            waterwayDesignStations[index].depthEdited = Boolean(value);
            waterwayDesignStations[index].flowDepthFB = Number(value);
            waterwayDesignStations[index].depth = Number(value);
            if (waterwayDesignStations[index].widthEdited) {
                waterwayDesignStations[index].widthEdited = false;
                waterwayDesignStations[index].flowTopWidth = '0.0';
                waterwayDesignStations[index].width = '0.0';
            }
        } else if (name === 'flowTopWidth') {
            waterwayDesignStations[index].widthEdited = Boolean(value);
            waterwayDesignStations[index].flowTopWidth = Number(value);
            waterwayDesignStations[index].width = Number(value);
            if (waterwayDesignStations[index].depthEdited) {
                waterwayDesignStations[index].depthEdited = false;
                waterwayDesignStations[index].flowDepthFB = '0.0';
                waterwayDesignStations[index].depth = '0.0';
            }
        }
        const flowDepthWidthEditedStationDTO: IWaterwayVertexParamDTO = convertStationBasedOnWaterwayVertexParamDTO(waterwayDesignStations[index], waterwayStore.channelControl);
        if (map) {
            map.set(reachId, flowDepthWidthEditedStationDTO);
        } else {
            const flowDepthWidthEditedStationObject = new Map();
            flowDepthWidthEditedStationObject.set(reachId, flowDepthWidthEditedStationDTO);
            waterwayStore.waterwayDesignObject.waterwayDesignStations = waterwayDesignStations;
            await this.props.addWDTEdits(flowDepthWidthEditedStationObject, true, true);
        }
    }

    // Reset Flow Depth -->
    @action.bound resetFlowDepth(e: any, item: any, index: number) { this.handleFlowDepthWidthChange('flowDepthFB', 0, index) }
    @action.bound async resetAllFlowDepth() {
        waterwayStore.selectedWaterwayStations = [];
        this.profileStore.unTrackProfilePoints();
        const waterwayDesignStations = this.currentObject.waterwayDesignStations;
        const flowDepthWidthEditedStationObject = new Map();
        waterwayDesignStations.forEach((el, index: number) => {
            if (el.depthEdited) this.handleFlowDepthWidthChange('flowDepthFB', 0, index, flowDepthWidthEditedStationObject)
        });
        await this.props.addWDTEdits(flowDepthWidthEditedStationObject, true, true);
    }

    // Reset Flow Width -->
    @action.bound resetFlowWidth(e: any, item: any, index: number) { this.handleFlowDepthWidthChange('flowTopWidth', 0, index) }
    @action.bound async resetAllFlowWidth() {
        waterwayStore.selectedWaterwayStations = [];
        this.profileStore.unTrackProfilePoints();
        const waterwayDesignStations = this.currentObject.waterwayDesignStations;
        const flowDepthWidthEditedStationObject = new Map();
        waterwayDesignStations.forEach((el, index: number) => {
            if (el.widthEdited) this.handleFlowDepthWidthChange('flowTopWidth', 0, index, flowDepthWidthEditedStationObject)
        });
        await this.props.addWDTEdits(flowDepthWidthEditedStationObject, true, true);
    }

    @action.bound async handleChannelParamEdit(name: string, value: any, index: number) {
        const waterwayDesignStations = this.currentObject.waterwayDesignStations;
        waterwayDesignStations[index][name] = value;
        let syncChannelParams = false;

        if (['leftSS', 'bottomWidth', 'rightSS', 'offset1', 'offset2', 'offset3'].includes(name)) {
            switch (name) {
                case 'leftSS':
                    waterwayDesignStations[index].channelParams.leftSlopeRatio = value;
                    // sync the channel parameters between R-0 and R-1
                    if (waterwayDesignStations[index].reachId === 'R-1') {
                        waterwayDesignStations[index - 1][name] = value;
                        waterwayDesignStations[index - 1].channelParams.leftSlopeRatio = value;
                        syncChannelParams = true;
                    }
                    break;

                case 'rightSS':
                    waterwayDesignStations[index].channelParams.rightSlopeRatio = value;
                    if (waterwayDesignStations[index].reachId === 'R-1') {
                        waterwayDesignStations[index - 1][name] = value;
                        waterwayDesignStations[index - 1].channelParams.rightSlopeRatio = value;
                        syncChannelParams = true;
                    }
                    break;
                case 'bottomWidth':
                    waterwayDesignStations[index].channelParams.minBedWidth = value;
                    if (waterwayDesignStations[index].reachId === 'R-1') {
                        waterwayDesignStations[index - 1][name] = value;
                        waterwayDesignStations[index - 1].channelParams.minBedWidth = value;
                        syncChannelParams = true;
                    }
                    break;
                case 'offset1':
                case 'offset2':
                case 'offset3':
                    waterwayDesignStations[index].channelParams[name] = value;
                    if (waterwayDesignStations[index].reachId === 'R-1') {
                        waterwayDesignStations[index - 1][name] = value;
                        waterwayDesignStations[index - 1].channelParams[name] = value;
                        syncChannelParams = true;
                    }
                    break;
            }
        }
        const editedStation = { ...waterwayDesignStations[index] };
        const editedStationDTO: IWaterwayVertexParamDTO = convertStationBasedOnWaterwayVertexParamDTO(editedStation, waterwayStore.channelControl)
        const editedStationObject = new Map();
        editedStationObject.set(editedStation.reachId, editedStationDTO)
        await this.props.addWDTEdits(editedStationObject, true, !syncChannelParams);
        if (syncChannelParams) {
            const editedStation = { ...waterwayDesignStations[index - 1] };
            const editedStationDTO: IWaterwayVertexParamDTO = convertStationBasedOnWaterwayVertexParamDTO(editedStation, waterwayStore.channelControl)
            const editedStationObject = new Map();
            editedStationObject.set(editedStation.reachId, editedStationDTO)
            await this.props.addWDTEdits(editedStationObject, true, syncChannelParams);
        }
    }

    @action.bound async handleTableInputChange(event: any, index: number) {
        if (!this.changedInputValue) {
            return
        }
        this.changedInputValue = false;
        const { value, name } = event.target;
        const waterwayDesignStations = this.currentObject.waterwayDesignStations;
        const { alignedDesignElementId } = waterwayStore;

        let editedValue: string;
        // Check if the value is empty
        if (value === undefined || value.length === 0) {
            const capitalizedName = name.charAt(0).toUpperCase() + name.slice(1);
            await MessageCenter.addNotificationFromCode('Common_08', undefined, capitalizedName);
            // Set the corresponding 'Valid' field to false
            this.formValidationReachTable[name + 'Valid'] = false;
            this.formValidationReachTable.invalidFields.push({ fieldName: name, index });
            return
        }
        // Check if the edited field is valid
        const editedFieldValid = this.formValidationReachTable[name + 'Valid'];
        // Check if all fields are valid
        const allFieldsValid = Object.keys(this.formValidationReachTable)
            .filter(key => key.endsWith('Valid'))  // Only consider the 'Valid' keys
            .every(key => this.formValidationReachTable[key]);  // Check if all 'Valid' keys are true

        if (/^-\d+(\.\d+)?$/.test(event.target.value) && name != "addedQ" && name != "flowDepthFB" && name != "grade") {
            //show message for negative input. clear the contents.
            event.target.value = "";
            MessageCenter.addErrorFromCode('WDT_101');
            return;
        }
        if (name == "station" && this.tableStore.validateStationInput(event)) {
            //station textbox can have 2 types of input example: '1+23' or '123'
            if (event.target.value.indexOf("+") !== -1) {
                //input format is: '1+23'
                editedValue = value;
            }
            else {
                //input format is: '123', convert here to '1+23'
                editedValue = this.tableStore.formatWaterwayStation(event.target.value);
            }

            if (index === 1 || index === waterwayDesignStations.length - 2) { // Only need to perform this check if editing R-0 or last Reach. The rest of the code handles other reaches.
                if (Number(editedValue.replace('+', '')) < waterwayStore.waterwayDesignObject.startGuardrail || Number(editedValue.replace('+', '')) > waterwayStore.waterwayDesignObject.endGuardrail) {
                    MessageCenter.addWarningFromCode('WDT_73');
                    waterwayDesignStations[index][name] = this.previousStation;
                    return;
                }
            }

            waterwayDesignStations[index][name] = editedValue;
            //Validate the station input range
            const currentStation = parseFloat(editedValue.replace('+', ''));
            const prevStation = index > 0 ? parseFloat(waterwayDesignStations[index - 1].station.replace('+', '')) : null;
            const nextStation = index < waterwayDesignStations.length - 1 ? parseFloat(waterwayDesignStations[index + 1].station.replace('+', '')) : null;

            if ((index !== 1 && prevStation !== null && currentStation < prevStation) || (index !== waterwayDesignStations.length - 2 && nextStation !== null && currentStation > nextStation)) {
                MessageCenter.addErrorFromCode('WDT_102');
                this.formValidationReachTable[name + 'Valid'] = false;
                this.formValidationReachTable.invalidFields.push({ fieldName: name, index });
                return;
            }
            this.validateStationAndElevation(editedFieldValid, allFieldsValid, waterwayDesignStations, index);
        }
        if (name == "channelZ" && this.tableStore.validateStationInput(event)) {
            //Validate the station input range
            const currentChannelZ = parseFloat(value);
            const throwError = this.validateTableElevation(index, waterwayDesignStations, currentChannelZ);
            if (throwError) {
                MessageCenter.addErrorFromCode('WDT_107');
                this.formValidationReachTable[name + 'Valid'] = false;
                this.formValidationReachTable.invalidFields.push({ fieldName: name, index });

                return;
            }
            if (editedFieldValid && allFieldsValid) {
                waterwayDesignStations[index][name] = value;
            }
            this.validateStationAndElevation(editedFieldValid, allFieldsValid, waterwayDesignStations, index);
        }
        if (name === 'flowDepthFB') {
            const floatValue = parseFloat(value);
            if (floatValue < 0.01 || floatValue > 10.00) {
                MessageCenter.addErrorFromCode('WDT_45');
                this.formValidationReachTable[name + 'Valid'] = false;
                this.formValidationReachTable.invalidFields.push({ fieldName: name, index });
                return;
            }
            if (editedFieldValid && allFieldsValid) {
                this.confirmFlowDepthWidthEdit(name, value, index);
            }
        } else if (name === 'flowTopWidth') {
            const floatValue = parseFloat(value);
            if (floatValue < 0.01 || floatValue > 100.00) {
                MessageCenter.addErrorFromCode('WDT_46');
                this.formValidationReachTable[name + 'Valid'] = false;
                this.formValidationReachTable.invalidFields.push({ fieldName: name, index });
                return;
            }
            if (editedFieldValid && allFieldsValid) {
                this.confirmFlowDepthWidthEdit(name, value, index);
            }
        }
        if (['leftSS', 'bottomWidth', 'rightSS', 'offset1', 'offset2', 'offset3'].includes(name)) {
            if (name === 'leftSS' || name === 'rightSS' || name === 'bottomWidth') {
                if (parseFloat(value) < 0.01 || parseFloat(value) > 100) {

                    // Show an error message or handle the validation failure
                    if (name === 'leftSS' && waterwayDesignStations[index].channelShapeType === 'PARABOLIC') {
                        await MessageCenter.addErrorFromCode('WDT_36');
                        this.formValidationReachTable[name + 'Valid'] = false;
                        this.formValidationReachTable.invalidFields.push({ fieldName: name, index });
                    } else if (name === 'leftSS' || name === 'rightSS') {
                        await MessageCenter.addErrorFromCode('WDT_42');

                        this.formValidationReachTable[name + 'Valid'] = false;
                        this.formValidationReachTable.invalidFields.push({ fieldName: name, index });

                    } else if (name === 'bottomWidth') {
                        await MessageCenter.addErrorFromCode('WDT_43');
                        this.formValidationReachTable[name + 'Valid'] = false;
                        this.formValidationReachTable.invalidFields.push({ fieldName: name, index });
                    }
                    return;
                }
            } else if (name === 'offset1' || name === 'offset2' || name === 'offset3') {
                if (parseFloat(value) < 0.0 || parseFloat(value) > 100) {
                    await MessageCenter.addErrorFromCode('WDT_18');
                    this.formValidationReachTable[name + 'Valid'] = false;
                    this.formValidationReachTable.invalidFields.push({ fieldName: name, index });
                    return;
                }
            }
            if (editedFieldValid && allFieldsValid) {
                this.handleChannelParamEdit(name, value, index);
            }
        }
        if (name == "addedQ") {
            if (!value.isNaN && editedFieldValid && allFieldsValid) {
                if (parseFloat(value) < 0.0) {
                    await MessageCenter.addWarningFromCode('WDT_117');
                }
                const diffAddedQ = Number(value) - Number(this.previousAddedQ);
                // const updatedRunoffQ = Number(waterwayDesignStations[index]['runoffQ']) + Number(diffAddedQ);
                waterwayDesignStations[index][name] = Number(value).toFixed(1);
                waterwayDesignStations.forEach((station, idx) => {
                    if (idx >= index && idx < waterwayDesignStations.length - 1) {
                        // station.runoffQ = (Number(station.runoffQ) + Number(diffAddedQ)).toFixed(1);
                        station.totalQ = (Number(station.totalQ) + Number(diffAddedQ)).toFixed(1);
                    }
                });
                const editedWaterwayVertexData = new Map();
                const editedStationDTO: IWaterwayVertexParamDTO = convertStationBasedOnWaterwayVertexParamDTO(waterwayDesignStations[index], waterwayStore.channelControl)
                editedWaterwayVertexData.set(waterwayDesignStations[index].reachId, editedStationDTO);
                await this.props.addWDTEdits(editedWaterwayVertexData, true, true);
            } else {
                waterwayDesignStations[index].addedQ = this.previousAddedQ;
                // MessageCenter.addWarning('AddedQ must be a positive numeric value. Please review.');
            }
        }
        if (name === 'grade') {
            waterwayStore.gradeEdited = true;
            waterwayStore.startGradeNegative = false;
            waterwayStore.endGradeNegative = false;
            const startReach = waterwayDesignStations.find(reach => reach.reachId === 'START');
            const endReach = waterwayDesignStations.find(reach => reach.reachId === 'END');
            const editedReachId = index === 0 ? 'START' : index === waterwayDesignStations.length - 1 ? 'END' : waterwayDesignStations[index]?.reachId;
            const editedReach = waterwayDesignStations.find(reach => reach.reachId === editedReachId);
            const grade = parseFloat(editedReach.grade);
            // Check if grade is not a number or out of range [-5%, 5%]
            if (isNaN(grade) || grade < -5 || grade > 5) {
                MessageCenter.addErrorFromCode('WDT_138');
                this.formValidationReachTable[name + 'Valid'] = false;
                this.formValidationReachTable.invalidFields.push({ fieldName: name, index });
                return;
            }
            // Warning for negative slope
            if (grade < 0) {
                MessageCenter.addWarningFromCode('WDT_139');
            }
            let response;
            try {
                response = await WaterwayDesignToolsController.updateWaterwayDesignControlSettingsUsingPOST({
                    alignedElementDesignParametersId: alignedDesignElementId,
                    channelEndsControlType: 1,
                    startSlopeDistance: 0,
                    endSlopeDistance: 0,
                    startSlopePercentage: editedReachId === 'START' ? Number(editedReach.grade) : Number(startReach.grade),
                    endSlopePercentage: editedReachId === 'END' ? Number(editedReach.grade) : Number(endReach.grade),
                    designControlSyncDisabled: true
                });
                this.formValidationReachTable['stationLength' + 'Valid'] = true;
                this.formValidationReachTable.invalidFields = this.formValidationReachTable.invalidFields.filter(field => field.fieldName !== 'stationLength');
            } catch (error) {
                MessageCenter.addErrorFromCode('WDT_127');
                this.formValidationReachTable[name + 'Valid'] = false;
                this.formValidationReachTable.invalidFields.push({ fieldName: name, index });
                return;
            }

            const editedWaterwayVertexData = new Map();
            const editedStationDTO: IWaterwayVertexParamDTO = convertStationBasedOnWaterwayVertexParamDTO(editedReach, waterwayStore.channelControl);
            editedWaterwayVertexData.set(editedReach.reachId, editedStationDTO);
            if (editedFieldValid && allFieldsValid) {
                if (editedReachId === "START" || editedReachId === "END") {
                    this.storedEdits.push(editedWaterwayVertexData);
                } else {
                    await this.props.addWDTEdits(editedWaterwayVertexData, true, true);
                }
            }

            if (response && response.data) {
                const { startSlopeDistance, startSlopePercentage, endSlopeDistance, endSlopePercentage } = response.data;
                if (editedReachId === 'START') {
                    waterwayStore.channelStartGradeLengthChangedGlobal = true;
                    startReach.stationLength = startSlopeDistance ? parseFloat(startSlopeDistance.toFixed(1)) : 0;
                    startReach.stationDist = startSlopeDistance ? parseFloat(startSlopeDistance.toFixed(1)) : 0;
                    startReach.grade = startSlopePercentage ? parseFloat(startSlopePercentage.toFixed(2)) : 0;
                    waterwayStore.waterwayDesignObject.startGuardrail = startSlopeDistance ? parseFloat(startSlopeDistance.toFixed(2)) : 0;
                    waterwayStore.waterwayDesignObject.startGradeLength = startReach.stationLength;
                    if (Number(startReach.stationLength) < 0 || Number(startReach.stationLength) > 50) {
                        MessageCenter.addErrorFromCode('WDT_137');
                        this.formValidationReachTable['stationLength' + 'Valid'] = false;
                        this.formValidationReachTable.invalidFields.push({ fieldName: 'stationLength', index });
                        return;
                    }
                    await this.truncateReachesOutsideControlLimit();
                    await this.tableStore.calculateNewStartOrEndReach(0, waterwayDesignStations, false)
                    await this.profileStore.createReachLineFromSavedWaterway()
                } else if (editedReachId === 'END') {
                    waterwayStore.channelEndGradeLengthChangedGlobal = true;
                    endReach.stationLength = endSlopeDistance ? parseFloat(endSlopeDistance.toFixed(1)) : 0;
                    endReach.stationDist = endSlopeDistance ? parseFloat(endSlopeDistance.toFixed(1)) : 0;
                    endReach.grade = endSlopePercentage ? parseFloat(endSlopePercentage.toFixed(2)) : 0;
                    waterwayStore.waterwayDesignObject.endGuardrail = toDecimalPrecision((waterwayStore.endStation_XCenterLine - (endSlopeDistance ? parseFloat(endSlopeDistance.toFixed(2)) : 0)), 1);
                    waterwayStore.waterwayDesignObject.endGradeLength = endReach.stationLength;

                    if (Number(endReach.stationLength) < 0 || Number(endReach.stationLength) > 50) {
                        MessageCenter.addErrorFromCode('WDT_137');
                        this.formValidationReachTable['stationLength' + 'Valid'] = false;
                        this.formValidationReachTable.invalidFields.push({ fieldName: 'stationLength', index });
                        return;
                    }
                    await this.truncateReachesOutsideControlLimit();
                    await this.tableStore.calculateNewStartOrEndReach(waterwayDesignStations.length - 1, waterwayDesignStations, false)
                    await this.profileStore.createReachLineFromSavedWaterway()
                }
            }
            this.tableStore.checkSlopeDirection(waterwayDesignStations);
            await this.profileStore.drawGuardrail();
            waterwayStore.gradeEdited = false;
        }

        if (name === 'stationLength') {
            waterwayStore.stationLengthEdited = true;
            waterwayStore.startGradeNegative = false;
            waterwayStore.endGradeNegative = false;
            const startReach = waterwayDesignStations.find(reach => reach.reachId === 'START');
            const endReach = waterwayDesignStations.find(reach => reach.reachId === 'END');
            const editedReachId = index === 0 ? 'START' : index === waterwayDesignStations.length - 1 ? 'END' : waterwayDesignStations[index]?.reachId;
            const editedReach = waterwayDesignStations.find(reach => reach.reachId === editedReachId);
            const stationLength = editedReach.stationLength;
            if (!/^[\d.]+$/.test(stationLength) || Number(stationLength) < 0 || Number(stationLength) > 50) {
                MessageCenter.addErrorFromCode('WDT_137');
                this.formValidationReachTable[name + 'Valid'] = false;
                this.formValidationReachTable.invalidFields.push({ fieldName: name, index });
                return;
            }
            let response;
            try {
                response = await WaterwayDesignToolsController.updateWaterwayDesignControlSettingsUsingPOST({
                    alignedElementDesignParametersId: alignedDesignElementId,
                    channelEndsControlType: 0,
                    startSlopeDistance: editedReachId === 'START' ? Number(editedReach.stationLength) : Number(startReach.stationLength),
                    endSlopeDistance: editedReachId === 'END' ? Number(editedReach.stationLength) : Number(endReach.stationLength),
                    startSlopePercentage: 0,
                    endSlopePercentage: 0,
                    designControlSyncDisabled: true
                });
                this.formValidationReachTable['grade' + 'Valid'] = true;
                this.formValidationReachTable.invalidFields = this.formValidationReachTable.invalidFields.filter(field => field.fieldName !== 'grade');
            } catch (error) {
                MessageCenter.addErrorFromCode('WDT_127');
                this.formValidationReachTable[name + 'Valid'] = false;
                this.formValidationReachTable.invalidFields.push({ fieldName: name, index });
            }

            const editedWaterwayVertexData = new Map();
            const editedStationDTO: IWaterwayVertexParamDTO = convertStationBasedOnWaterwayVertexParamDTO(editedReach, waterwayStore.channelControl);
            editedWaterwayVertexData.set(editedReach.reachId, editedStationDTO);
            if (editedFieldValid && allFieldsValid) {
                if (editedReachId === "START" || editedReachId === "END") {
                    this.storedEdits.push(editedWaterwayVertexData);
                } else {
                    await this.props.addWDTEdits(editedWaterwayVertexData, true, true);
                }
            }

            if (response && response.data) {
                const { startSlopeDistance, startSlopePercentage, endSlopeDistance, endSlopePercentage } = response.data;
                if (editedReachId === 'START') {
                    waterwayStore.channelStartGradeLengthChangedGlobal = true;
                    startReach.stationLength = startSlopeDistance ? parseFloat(startSlopeDistance.toFixed(2)) : 0;
                    startReach.stationDist = startSlopeDistance ? parseFloat(startSlopeDistance.toFixed(2)) : 0;
                    startReach.grade = startSlopePercentage ? parseFloat(startSlopePercentage.toFixed(2)) : 0;
                    waterwayStore.waterwayDesignObject.startGuardrail = startSlopeDistance ? parseFloat(startSlopeDistance.toFixed(2)) : 0;
                    waterwayStore.waterwayDesignObject.startGradeLength = startReach.stationLength;
                    if (startReach.grade < -5 || startReach.grade > 5) {
                        MessageCenter.addErrorFromCode('WDT_138');
                        this.formValidationReachTable['grade' + 'Valid'] = false;
                        this.formValidationReachTable.invalidFields.push({ fieldName: 'grade', index });
                        return;
                    }
                    if (startReach.grade < 0) {
                        MessageCenter.addWarningFromCode('WDT_139');
                    }
                    await this.truncateReachesOutsideControlLimit();
                    await this.tableStore.calculateNewStartOrEndReach(0, waterwayDesignStations, false)
                    await this.profileStore.createReachLineFromSavedWaterway()

                } else if (editedReachId === 'END') {
                    waterwayStore.channelEndGradeLengthChangedGlobal = true;
                    endReach.stationLength = endSlopeDistance ? parseFloat(endSlopeDistance.toFixed(2)) : 0;
                    endReach.stationDist = endSlopeDistance ? parseFloat(endSlopeDistance.toFixed(2)) : 0;
                    endReach.grade = endSlopePercentage ? parseFloat(endSlopePercentage.toFixed(2)) : 0;
                    waterwayStore.waterwayDesignObject.endGuardrail = toDecimalPrecision((waterwayStore.endStation_XCenterLine - (endSlopeDistance ? parseFloat(endSlopeDistance.toFixed(2)) : 0)), 1);
                    waterwayStore.waterwayDesignObject.endGradeLength = endReach.stationLength;
                    if (endReach.grade < -5 || endReach.grade > 5) {
                        MessageCenter.addErrorFromCode('WDT_138');
                        this.formValidationReachTable['grade' + 'Valid'] = false;
                        this.formValidationReachTable.invalidFields.push({ fieldName: 'grade', index });
                        return;
                    }
                    if (endReach.grade < 0) {
                        MessageCenter.addWarningFromCode('WDT_139');
                    }
                    await this.truncateReachesOutsideControlLimit();
                    await this.tableStore.calculateNewStartOrEndReach(waterwayDesignStations.length - 1, waterwayDesignStations, false)
                    await this.profileStore.createReachLineFromSavedWaterway()
                }
            }
            this.tableStore.checkSlopeDirection(waterwayDesignStations);
            await this.profileStore.drawGuardrail();
            waterwayStore.stationLengthEdited = false;
        }
    }

    private validateStationAndElevation(editedFieldValid, allFieldsValid, waterwayDesignStations, index) {
        if (editedFieldValid && allFieldsValid) {
            const editedStation = [waterwayDesignStations[index].station, waterwayDesignStations[index].channelZ * (designStore.commonVerticalStretchFactor || AppConstants.profileStretchFactor)];
            const info = { index: index, point: editedStation }
            this.profileStore.editWaterway(info, this.props.addWDTEdits);
        }

        const xScale = designStore.commonHorizontalStretchFactor ? designStore.commonHorizontalStretchFactor : 1;
        const x = parseStationString(waterwayDesignStations[index].station) * xScale;
        const y = parseFloat(waterwayDesignStations[index].channelZ) * (designStore.commonVerticalStretchFactor || AppConstants.profileStretchFactor);
        if (this.profileStore.checkAboveCenterline(x, y)) {
            MessageCenter.addWarningFromCode('WDT_106');
        }
        if (this.profileStore.verifyDistanceWithinLimit(x, y, 2)) {
            MessageCenter.addWarningFromCode('WDT_110');
        }
    }

    private validateTableElevation(index, stations, currentChannelZ) {
        let throwError: boolean = false;
        const prevChannelZ = index > 0 ? parseFloat(stations[index - 1].channelZ) : null;
        const nextChannelZ = index < stations.length - 1 ? parseFloat(stations[index + 1].channelZ) : null;
        const originalChannelZ = parseFloat(waterwayStore.waterwayStationsEditingClone[index].channelZ);

        if (prevChannelZ !== null && nextChannelZ !== null) {

            if (index === 1) {
                if ((originalChannelZ > nextChannelZ && currentChannelZ < nextChannelZ) || (originalChannelZ < nextChannelZ && currentChannelZ > nextChannelZ)) {
                    throwError = true;
                }
            } else if (index === stations.length - 2) {
                if ((originalChannelZ < prevChannelZ && currentChannelZ > prevChannelZ) || (originalChannelZ > prevChannelZ && currentChannelZ < prevChannelZ)) {
                    throwError = true;
                }
            } else {
                if ((prevChannelZ > nextChannelZ && (currentChannelZ > prevChannelZ || currentChannelZ < nextChannelZ)) || (prevChannelZ < nextChannelZ && (currentChannelZ < prevChannelZ || currentChannelZ > nextChannelZ))) {
                    throwError = true;
                }
            }
        }
        if (!throwError) {
            waterwayStore.waterwayStationsEditingClone[index].channelZ = currentChannelZ;
        }

        return throwError;
    }

    @action.bound handleTableFocus(event: any) {
        const { value, name } = event.target;
        const label = event.target.getAttribute('aria-label');
        if (name === 'addedQ') {
            this.previousAddedQ = value;
        } else if (name === 'station') {
            this.previousStation = value;
        } else if (name === 'flowDepthFB') {
            this.previousFlowDepthFB = value;
        } else if (name === 'flowTopWidth') {
            this.previousFlowTopWidth = value;
        } else if (name === 'stationLength') {
            if (label.endsWith('-0')) {
                this.prevStartSlopeDistance = Number(value);
                this.prevStartSlopePercentage = Number(waterwayStore.waterwayDesignObject.waterwayDesignStations[0].grade);
            } else {
                this.prevEndSlopeDistance = Number(value);
                this.prevEndSlopePercentage = Number(waterwayStore.waterwayDesignObject.waterwayDesignStations[waterwayStore.waterwayDesignObject.waterwayDesignStations.length - 1].grade);
            }
        } else if (name === 'grade') {
            if (label.endsWith('-0')) {
                this.prevStartSlopePercentage = Number(value);
                this.prevStartSlopeDistance = Number(waterwayStore.waterwayDesignObject.waterwayDesignStations[0].stationLength);
            } else {
                this.prevEndSlopePercentage = Number(value);
                this.prevEndSlopeDistance = Number(waterwayStore.waterwayDesignObject.waterwayDesignStations[waterwayStore.waterwayDesignObject.waterwayDesignStations.length - 1].stationLength);
            }
        }
    }

    // Currently this function is no longer used in .tsx, commented in case of future needs
    /*     // Function to get warning description
        @action.bound async getWarningDescription(errorId: string, status: string): Promise<string> {
            if (status == "WARNING_STATUS") {
                try {
                    const response = await ErrorHandlingController.getErrorHandlingByOriginalErrorCodesUsingGET(errorId.slice(0, 6));
                    if (response && response.data && response.data.length > 0 && response.data[0].errorShortDescription) {
                        return response.data[0].errorShortDescription;
                    } else {
                        return 'invalid warning';
                    }
    
                } catch (error) {
                    return "invalid warning";
                }
            }
            return '';
        } */

    // NOTE: createReachLineFromSavedWaterway was moved to profileStore

    @action.bound async updateStartEndStations(holdPEM: boolean = false, lastEdit: boolean = false) {
        if (waterwayStore.alignedDesignElementId && waterwayStore.waterwayDesignObject.waterwayDesignStations.length) {
            const stations = waterwayStore.waterwayDesignObject.waterwayDesignStations;
            const editedWaterwayVertexData = new Map();
            this.startEndStationsUpdated = false;
            // Handle START
            if (waterwayStore.channelStartGradeLengthChangedGlobal ||
                Number(stations[0].stationLength).toFixed(1) !== Number(waterwayStore.waterwayDesignObject.startGradeLength).toFixed(1)) {
                const startStation = await this.tableStore.calculateNewStartOrEndReach(0, stations);
                const startStationDTO: IWaterwayVertexParamDTO = convertStationBasedOnWaterwayVertexParamDTO(startStation, waterwayStore.channelControl)
                editedWaterwayVertexData.set('START', startStationDTO);
                this.startEndStationsUpdated = true;
            }
            // Handle END
            if (waterwayStore.channelEndGradeLengthChangedGlobal || Number(stations[stations.length - 1].stationLength).toFixed(1) !== Number(waterwayStore.waterwayDesignObject.endGradeLength).toFixed(1)) {
                const endStation = await this.tableStore.calculateNewStartOrEndReach(stations.length - 1, stations);
                const endStationDTO: IWaterwayVertexParamDTO = convertStationBasedOnWaterwayVertexParamDTO(endStation, waterwayStore.channelControl)
                editedWaterwayVertexData.set('END', endStationDTO);
                this.startEndStationsUpdated = true;
            }
            if (this.startEndStationsUpdated) {
                if (!holdPEM && (waterwayStore.channelStartGradeLengthChangedGlobal || waterwayStore.channelEndGradeLengthChangedGlobal) && lastEdit) {
                    await this.props.addWDTEdits(editedWaterwayVertexData, false, lastEdit);

                }
                else {
                    this.storedEdits.push(editedWaterwayVertexData);
                }
            }
        }
    }

    private async truncateReachesOutsideControlLimit() {
        this.waterwayTruncated = false;
        if (waterwayStore.alignedDesignElementId && this.currentObject.waterwayDesignStations.length
            && (waterwayStore.waterwayDesignObject.startGuardrail || waterwayStore.waterwayDesignObject.endGuardrail)) {
            const startGuardrail = waterwayStore.waterwayDesignObject.startGuardrail;
            const endGuardrail = waterwayStore.waterwayDesignObject.endGuardrail;
            const stations = this.currentObject.waterwayDesignStations;
            await this.storeWaterwayDesignStations();
            for (let n = 1; n < stations.length - 1;) {
                if (stations[n].station) {
                    if (Number(stations[n].station.replace('+', '')) >= startGuardrail && Number(stations[n].station.replace('+', '')) < endGuardrail) {
                        n++;
                        continue;
                    } else if (Number(stations[n].station.replace('+', '')) < startGuardrail && Number(stations[n + 1].station.replace('+', '')) < startGuardrail) {
                        this.waterwayTruncated = true;
                        // delete the reach when both start and end stations are outside the startGuardrail
                        const deletedReachId = stations[n].reachId;
                        const editedWaterwayVertexData = new Map();
                        const wvparam = stations[n];
                        wvparam.reachId = 'Delete';

                        const deleteStationDTO: IWaterwayVertexParamDTO = convertStationBasedOnWaterwayVertexParamDTO(wvparam, waterwayStore.channelControl);
                        editedWaterwayVertexData.set(deletedReachId, deleteStationDTO);

                        stations.splice(n, 1);
                        stations.forEach((station, idx) => {
                            if (idx > 0 && idx < stations.length - 1) {
                                const originalReachId = station.reachId;
                                if (idx == 1) {
                                    station.reachId = 'R-0';
                                    station.startStation = '';
                                    station.stationLength = 0.0;
                                    station.grade = 0.0;
                                } else if (idx > 1 && idx < stations.length - 1) {
                                    station.reachId = 'R-' + (Number(station.reachId.substring(2)) - 1);
                                }
                                const deleteStationDTO: IWaterwayVertexParamDTO = convertStationBasedOnWaterwayVertexParamDTO(station, waterwayStore.channelControl)
                                editedWaterwayVertexData.set(originalReachId, deleteStationDTO)
                            }
                        });
                        this.storedEdits.push(editedWaterwayVertexData);
                        continue;
                    } else if (Number(stations[n].station.replace('+', '')) < startGuardrail && Number(stations[n + 1].station.replace('+', '')) >= startGuardrail) {
                        this.waterwayTruncated = true;
                        // move the start station to the startGuardrail when start station is outside the startGuardrail
                        const intersectY = this.getIntersectionOfReaches(
                            { x: Number(stations[n].station.replace('+', '')), y: stations[n].channelZ },
                            { x: Number(stations[n + 1].station.replace('+', '')), y: stations[n + 1].channelZ },
                            startGuardrail);
                        stations[n].station = formatStationString(startGuardrail.toFixed(1));
                        stations[n].endStation = formatStationString(startGuardrail.toFixed(1));
                        stations[n].channelZ = intersectY;

                        const dataX = Number(startGuardrail.toFixed(1));
                        const dataY = stations[n].channelZ;
                        const newVertex: XyzPoint = new XyzPoint(dataX, dataY, 0);

                        const storedEdit = await this.tableStore.modifyRows(newVertex, n - 1, this.props.addWDTEdits, true);
                        this.storedEdits.push(storedEdit);
                        n++;
                    } else if (Number(stations[n].station.replace('+', '')) >= endGuardrail) {
                        if (Number(stations[n].station.replace('+', '')) > endGuardrail) {
                            this.waterwayTruncated = true;
                            // move the end station to the endGuardrail when end station is outside the endGuardrail
                            const intersectY = this.getIntersectionOfReaches(
                                { x: Number(stations[n - 1].station.replace('+', '')), y: stations[n - 1].channelZ },
                                { x: Number(stations[n].station.replace('+', '')), y: stations[n].channelZ },
                                endGuardrail);
                            stations[n].station = formatStationString(endGuardrail.toFixed(1));
                            stations[n].endStation = formatStationString(endGuardrail.toFixed(1));
                            stations[n].channelZ = intersectY;

                            const dataX = Number(endGuardrail.toFixed(1));
                            const dataY = stations[n].channelZ;
                            const newVertex: XyzPoint = new XyzPoint(dataX, dataY, 0);

                            const storedEdit = await this.tableStore.modifyRows(newVertex, n - 1, this.props.addWDTEdits, true);
                            this.storedEdits.push(storedEdit);
                        }

                        // delete rest of the stations;
                        for (let i = stations.length - 2; i > n; i--) {
                            this.waterwayTruncated = true;
                            const deletedReachId = stations[i].reachId;
                            const wvparam = stations[i];
                            wvparam.reachId = 'Delete';
                            const editedWaterwayVertexData = new Map();
                            const deleteStationDTO: IWaterwayVertexParamDTO = convertStationBasedOnWaterwayVertexParamDTO(wvparam, waterwayStore.channelControl);
                            editedWaterwayVertexData.set(deletedReachId, deleteStationDTO);
                            stations.splice(i, 1);
                            this.storedEdits.push(editedWaterwayVertexData);
                        }
                        break;
                    }
                } else {
                    n++;
                }
            }
            this.currentObject.waterwayDesignStations = stations;
        }
        if (!this.waterwayTruncated) {
            await this.updateStartEndStations(false, true);
            waterwayStore.channelStartGradeLengthChangedGlobal = false;
            waterwayStore.channelEndGradeLengthChangedGlobal = false;
        } else {
            // update the START/END and store for later when waterway being truncated
            await this.updateStartEndStations(true);
            // add confirmation warning when there are edits
            await MessageCenter.addWarningFromCode('WDT_113', [
                {
                    callback: async () => {
                        MessageCenter.clearMessages();
                        await this.resetStartEndLength();
                        this.profileStore.resetGuardrail();
                        this.profileStore.createReachLineFromSavedWaterway();
                        waterwayStore.channelStartGradeLengthChangedGlobal = false;
                        waterwayStore.channelEndGradeLengthChangedGlobal = false;
                    },
                    text: 'Cancel',
                },
                {
                    callback: async () => {
                        MessageCenter.clearMessages();
                        for (let i = 0; i < this.storedEdits.length; i++) {
                            const edit = this.storedEdits[i];
                            const lastEdit = i === this.storedEdits.length - 1 ? true : false;
                            await this.props.addWDTEdits(edit, false, lastEdit);
                            waterwayStore.channelStartGradeLengthChangedGlobal = false;
                            waterwayStore.channelEndGradeLengthChangedGlobal = false;
                        }
                        this.storedEdits = [];
                    },
                    text: 'OK',
                },
            ]);
        }
    }

    private getIntersectionOfReaches(station1: any, station2: any, intersectX: number) {
        const m = (station2.y - station1.y) / (station2.x - station1.x);
        const b = station1.y - m * station1.x;
        const calculatedY = m * intersectX + b;
        return calculatedY;
    }

    // Reset Setting -->
    // @observable resetSettingDialogIsOpen: boolean = false;

    // @action.bound toggleResetSettingDialog() {
    //     this.resetSettingDialogIsOpen = !this.resetSettingDialogIsOpen;
    // }

    // @action.bound async resetSetting() {
    //     if (this.resetSettingDialogIsOpen) this.toggleResetSettingDialog();
    //     await WaterwayDesignToolsController.resetWaterwayProfileResponseUsingDELETE(this.currentObject.alignedElementDesignParametersId);
    //     this.props.resetPEMReachEdits();
    //     this.profileStore.removeSketch();
    //     waterwayStore.selectedWaterwayStations = [];
    //     this.currentObject.waterwayDesignStations.length = 0;
    //     designStore.hasWaterwayCalculations = false;
    // }

    // fixed width/depth
    @observable fixedValueDialogIsOpen: boolean = false;

    @action.bound async setFixedWidth(e: any) {
        waterwayStore.selectedWaterwayStations = [];
        this.profileStore.unTrackProfilePoints();
        this.cancelFlag = false;
        this.fixedValue = 0.0.toFixed(1);
        if (designStore.wdtGroupsLength > 0) {
            await MessageCenter.addErrorFromCode('WDT_108');
        } else {
            this.fixedWidthOrDepth = 'width';
            this.toggleFixedValueDialog();
        }
    }

    @action.bound async setFixedDepth(e: any) {
        waterwayStore.selectedWaterwayStations = [];
        this.profileStore.unTrackProfilePoints();
        this.cancelFlag = false;
        this.fixedValue = 0.0.toFixed(1);
        if (designStore.wdtGroupsLength > 0) {
            await MessageCenter.addErrorFromCode('WDT_108');
        } else {
            this.fixedWidthOrDepth = 'depth';
            this.toggleFixedValueDialog();
        }
    }

    @action.bound toggleFixedValueDialog() {
        this.fixedValueDialogIsOpen = !this.fixedValueDialogIsOpen;
    }

    @action.bound cancelFixedValueDialog() {
        this.cancelFlag = true;
        this.fixedValueDialogIsOpen = !this.fixedValueDialogIsOpen;
        this.fixedValue = 0.0.toFixed(1);
        this.fixedWidthOrDepth = 'none';
    }

    @action.bound async setFixedValue(e: any) {
        this.cancelFlag = true
        if (this.fixedValueDialogIsOpen) this.toggleFixedValueDialog();

        if (!this.checkValidWidthOrDepth(this.fixedWidthOrDepth, Number(this.fixedValue))) {
            if (this.fixedWidthOrDepth === 'depth') {
                await MessageCenter.addErrorFromCode('WDT_45');
            } else if (this.fixedWidthOrDepth === 'width') {
                await MessageCenter.addErrorFromCode('WDT_46');
            }
            this.fixedValue = 0.0.toFixed(1);
            this.fixedWidthOrDepth = 'none';
            return;
        }

        let typeId: number;
        if (this.fixedWidthOrDepth === 'depth') typeId = 1;
        else if (this.fixedWidthOrDepth === 'width') typeId = 2;
        else typeId = 3;

        const payload = {
            alignedElementDesignParamsId: this.currentObject.alignedElementDesignParametersId,
            fixedValue: Number(this.fixedValue),
            fixedValueTypeId: typeId
        };
        const response = await WaterwayDesignToolsReachJsonController.updateFixedWidthOrDepthUsingPOST(payload);
        if (response && response.data && response.data.updatedReachParametersMap) {
            const data = response.data.updatedReachParametersMap;
            const stations = this.currentObject.waterwayDesignStations;
            stations.map(station => {
                if (data[station.reachId] && station.reachId.substring(0, 1) == 'R') {
                    station.flowTopWidth = typeId != 3 ? data[station.reachId].width?.toFixed(1) : data[station.reachId].simWidth?.toFixed(1);
                    station.flowDepthFB = typeId != 3 ? data[station.reachId].depth?.toFixed(1) : data[station.reachId].simDepth?.toFixed(1);
                    // station.simDepth = data[station.reachId].simDepth?.toFixed(1);
                    // station.simWidth = data[station.reachId].simWidth?.toFixed(1);
                    station.depthEdited = data[station.reachId].depthEdited;
                    station.widthEdited = data[station.reachId].widthEdited;
                    station.status = 'IN PROGRESS';
                }
            });
            waterwayStore.waterwayDesignObject.waterwayDesignStations = stations;
            if (waterwayStore.wdtGroupsOriginals.length > 0) waterwayStore.wdtGroupsOriginals[waterwayStore.wdtGroupsOriginals.length - 1].currentObject.waterwayDesignStations = JSON.parse(JSON.stringify(stations));
            await this.saveUiState('save');
            await this.getUiStateAndNotification();
        }
        this.fixedValue = 0.0.toFixed(1);
        this.fixedWidthOrDepth = 'none';
    }


    @action.bound async handleActionValueInputBlur(event: any) {
        if (!this.changedInputValue) {
            return
        }
        this.changedInputValue = false;
        const { value, name } = event.target;

        setTimeout(async () => {
            if (this.cancelFlag) {
                return
            }
            if (name === 'fixedValue') {
                if (!this.checkValidWidthOrDepth(this.fixedWidthOrDepth, value)) {
                    if (this.fixedWidthOrDepth === 'depth') {
                        await MessageCenter.addErrorFromCode('WDT_45');
                    } else if (this.fixedWidthOrDepth === 'width') {
                        await MessageCenter.addErrorFromCode('WDT_46');
                    }
                    this.fixedValue = 0.0.toFixed(1);
                } else {
                    this.fixedValue = value;
                }
            } else if (name === 'shiftElevation') {
                if (Number(value)) {
                    if (Number(value) < -2 || Number(value) > 2) {
                        await MessageCenter.addWarningFromCode('WDT_109');
                    }
                    this.shiftElevation = value;
                } else {
                    // await MessageCenter.addWarningFromCode('WDT_109');
                    this.shiftElevation = '0.0';
                }
            }
        }, 300);
    }

    @action.bound async saveUiState(type) {
        const uiSettingsDto: UiSettingsDto = {
            bankProfile: this.savedProfileSettingsForm.showBankSelection,
            fineGrid: this.savedProfileSettingsForm.input.fineGrid,
            lowBankOffset: this.savedProfileSettingsForm.input.lowBankOffset,
            sampleInterval: this.savedProfileSettingsForm.input.sampleInterval,
            verticalInterval: this.savedProfileSettingsForm.input.verticalInterval,
            showCoord: this.savedProfileSettingsForm.checked.showFineGrid
        }
        const AlignedElementUiStateDtoWithSettings: AlignedElementUiStateDto = {
            alignmentElementId: waterwayStore.alignedDesignElementId,
            // alignmentId: optinal, 
            channelShape: waterwayStore.channelControl,
            designElementTypeId: waterwayStore.waterwayType
                ? (waterwayStore.waterwayType === "Lined Waterway" ? 19 : 7)
                : waterwayStore.currentWaterwayDesignElementTypeId,
            endDistance: waterwayStore.waterwayDesignObject.endGradeLength,
            peakFlow: waterwayStore.waterwayDesignObject.peakFlow,
            startDistance: waterwayStore.waterwayDesignObject.startGradeLength,
            tableView: waterwayStore.tableView,
            uiSettingsDto: uiSettingsDto
        }
        const AlignedElementUiStateDtoWithoutSettings: AlignedElementUiStateDto = {
            alignmentElementId: waterwayStore.alignedDesignElementId,
            // alignmentId: optinal, 
            channelShape: waterwayStore.channelControl,
            designElementTypeId: waterwayStore.waterwayType
                ? (waterwayStore.waterwayType === "Lined Waterway" ? 19 : 7)
                : waterwayStore.currentWaterwayDesignElementTypeId,
            endDistance: waterwayStore.waterwayDesignObject.endGradeLength,
            peakFlow: waterwayStore.waterwayDesignObject.peakFlow,
            startDistance: waterwayStore.waterwayDesignObject.startGradeLength,
            tableView: waterwayStore.tableView,
            uiSettingsDto: undefined
        }

        if (type === "save") {
            const payload: EftProjUserInputDto = {
                alignedElementUiStateDto: AlignedElementUiStateDtoWithSettings,
                sessionUuid: designStore.projectsStore.currentSessionId,
                uiStateType: "ReachDesignSave"
            }
            await EftProjUserInputController.saveDesignUiStateUsingPOST(payload);
        }
        else if (type === "save&Calculate") {
            const payload: EftProjUserInputDto = {
                alignedElementUiStateDto: AlignedElementUiStateDtoWithSettings,
                sessionUuid: designStore.projectsStore.currentSessionId,
                uiStateType: "ReachDesignCalculate"
            }
            await EftProjUserInputController.saveDesignUiStateUsingPOST(payload);
            designStore.displayResultBanner = true;
        }
        else if (type === "generateSurface") {
            const payload: EftProjUserInputDto = {
                alignedElementUiStateDto: AlignedElementUiStateDtoWithSettings,
                sessionUuid: designStore.projectsStore.currentSessionId,
                uiStateType: "ReachDesignSurface"
            }
            await EftProjUserInputController.saveDesignUiStateUsingPOST(payload);
        }
        else if (type === "digitizeReaches") {
            const payload: EftProjUserInputDto = {
                alignedElementUiStateDto: AlignedElementUiStateDtoWithSettings,
                sessionUuid: designStore.projectsStore.currentSessionId,
                uiStateType: "WaterwayInputProceed"
            }
            await EftProjUserInputController.saveDesignUiStateUsingPOST(payload);
        }
        this.saveProfileSettingsFromLocalToDesignStore();
    }

    private checkValidWidthOrDepth(widthOrDepth: 'depth' | 'width' | 'none', value: number): boolean {
        let validValue = true;
        if (widthOrDepth === 'depth' && (value < 0.01 || value > 10)) {
            validValue = false;
        } else if (widthOrDepth === 'width' && (value < 0.01 || value > 100)) {
            validValue = false;
        }
        return validValue;
    }

    // shift waterway elevation
    @observable shiftElevationDialogIsOpen: boolean = false;

    @action.bound async setShiftElevation(e: any) {
        waterwayStore.selectedWaterwayStations = [];
        this.profileStore.unTrackProfilePoints();
        this.cancelFlag = false;
        this.shiftElevation = 0.0.toFixed(1);
        if (designStore.wdtGroupsLength > 0) {
            MessageCenter.addErrorFromCode('WDT_111');
        } else {
            this.toggleShiftElevationDialog();
        }
    }



    @action.bound toggleShiftElevationDialog() {
        this.shiftElevationDialogIsOpen = !this.shiftElevationDialogIsOpen;
    }

    @action.bound cancelShiftElevationDialog() {
        this.cancelFlag = true;
        this.shiftElevationDialogIsOpen = !this.shiftElevationDialogIsOpen;
        this.shiftElevation = 0.0.toFixed(1);
    }

    @action.bound async checkShiftElevation(e: any) {
        this.cancelFlag = true;
        if (this.shiftElevationDialogIsOpen) this.toggleShiftElevationDialog();

        if (Number(this.shiftElevation)) {
            if (Number(this.shiftElevation) < -2 || Number(this.shiftElevation) > 2) {
                await shiftElevationCallback('WDT_109', this.shiftWaterwayElevation.bind(this), this.cancel.bind(this));
            } else {
                this.shiftWaterwayElevation();
            }
        } else {
            // await MessageCenter.addWarningFromCode('WDT_109');
            this.shiftElevation = '0.0';
        }
        waterwayStore.waterwayDesignObject.DisableSaveButtonDesignPage = false;
        waterwayStore.waterwayDesignObject.disableCalculateButtonDesignPage = false;
        waterwayStore.waterwayDesignObject.hasWaterwayCalculations = false;
        designStore.displayResultBanner = false;
    }

    private async shiftWaterwayElevation() {
        try {
            this.profileStore.raiseStartLengthyProcessEvent(true);

            const xScale = designStore.commonHorizontalStretchFactor ? designStore.commonHorizontalStretchFactor : 1;
            const stations = this.currentObject.waterwayDesignStations;
            let isAboveCenterline = false;
            let isExceedDistance = false;
            stations.map((station: any, i: number) => {
                if (i > 0 && i < stations.length - 1) {
                    station.channelZ = (Number(station.channelZ) + Number(this.shiftElevation)).toFixed(1);
                    station.cutFill = parseFloat((parseFloat(station.channelZ) - station.groundZ).toFixed(1));
                    const x = parseStationString(station.station) * xScale;
                    const y = parseFloat(station.channelZ) * (designStore.commonVerticalStretchFactor || AppConstants.profileStretchFactor);
                    if (!isAboveCenterline) {
                        if (this.profileStore.checkAboveCenterline(x, y)) isAboveCenterline = true;
                    }
                    if (!isExceedDistance) {
                        if (this.profileStore.verifyDistanceWithinLimit(x, y, 2)) isExceedDistance = true;
                    }
                }
            });
            if (isAboveCenterline) MessageCenter.addWarningFromCode('WDT_106');
            if (isExceedDistance) MessageCenter.addWarningFromCode('WDT_110');


            await this.profileStore.redrawMappingProfiles();
            const movedWaterwayVertexData = new Map();
            stations.forEach((station: any, i: number) => {
                if (i > 0 && i < stations.length - 1) {
                    station.status = "IN PROGRESS";
                }
                const moveStationDTO: IWaterwayVertexParamDTO = convertStationBasedOnWaterwayVertexParamDTO(station, waterwayStore.channelControl)
                movedWaterwayVertexData.set(station.reachId, moveStationDTO);
            });
            await this.props.addWDTEdits(movedWaterwayVertexData, false, true);

            this.profileStore.createReachLineFromSavedWaterway();

            this.shiftElevation = 0.0.toFixed(1);
        } finally {
            this.profileStore.raiseStartLengthyProcessEvent(false);
        }
    }

    @action.bound cancel(): void {
        this.shiftElevation = 0.0.toFixed(1);
    }

    @action.bound userLeavingWarningOnOk() {
        return false;
    }

    @action.bound async resetStartEndLength() {
        if (this.waterwayTruncated || this.startEndStationsUpdated) {
            await this.reloadWaterwayDesignStations();
            // reset start/end length
            try {
                const payload = waterwayStore.savedPayload;
                if (payload && payload.designControlJson) {
                    payload.alignedElementDesignParamsId = waterwayStore.alignedDesignElementId ? waterwayStore.alignedDesignElementId : 0;
                    const designControlString = payload.designControlJson;
                    const designControlJson = JSON.parse(designControlString);
                    const waterwayDesignStations = this.currentObject.waterwayDesignStations;
                    const startReach = waterwayDesignStations.find(reach => reach.reachId === 'START');
                    const endReach = waterwayDesignStations.find(reach => reach.reachId === 'END');

                    // Reset START    
                    if (waterwayStore.channelStartGradeLengthChangedGlobal) {
                        designControlJson.startSlopeDistance = waterwayStore.startGradeLength = waterwayStore.waterwayDesignObject.startGradeLength = this.prevStartSlopeDistance;
                        designControlJson.startGradeSlope = waterwayStore.startGradeSlope = this.prevStartSlopePercentage;
                        startReach.stationLength = this.prevStartSlopeDistance;
                        startReach.stationDist = this.prevStartSlopeDistance;
                        startReach.grade = this.prevStartSlopePercentage;
                        await this.tableStore.calculateNewStartOrEndReach(0, waterwayStore.waterwayDesignObject.waterwayDesignStations, false)
                    }

                    // Reset END
                    if (waterwayStore.channelEndGradeLengthChangedGlobal) {
                        designControlJson.endSlopeDistance = waterwayStore.endGradeLength = waterwayStore.waterwayDesignObject.endGradeLength = this.prevEndSlopeDistance;
                        designControlJson.endGradeSlope = waterwayStore.endGradeSlope = this.prevEndSlopePercentage;
                        endReach.stationLength = this.prevEndSlopeDistance;
                        endReach.stationDist = this.prevEndSlopeDistance;
                        endReach.grade = this.prevEndSlopePercentage;
                        await this.tableStore.calculateNewStartOrEndReach(waterwayDesignStations.length - 1, waterwayDesignStations, false)
                    }

                    payload.designControlJson = JSON.stringify(designControlJson);
                    await WaterwayDesignToolsController.createOrUpdateAlignedElementDesignParamsUsingPOST(payload);
                    waterwayStore.updateStartEndLength = true;
                }
            }
            catch (e) {
                console.error(e);
            }
        }
    }

    async storeWaterwayDesignStations() {
        this.storedWaterwayStations = JSON.parse(JSON.stringify(this.currentObject.waterwayDesignStations));
    }

    async reloadWaterwayDesignStations() {
        if (this.storedWaterwayStations) {
            this.currentObject.waterwayDesignStations.length = 0;
            this.currentObject.waterwayDesignStations = this.storedWaterwayStations;
            this.storedWaterwayStations = undefined;
        }
    }

    @observable notification: any = {
        redigitizeReaches: '',
        resetSetting: '',
        unsavedEdits: '',
    }

    @action.bound async getErrors() {
        this.notification.redigitizeReaches = await MessageCenter.addErrorLabelFromCode('Profile_02');
        // this.notification.resetSetting = await MessageCenter.addErrorLabelFromCode('Profile_03');
        // this.notification.unsavedEdits = await MessageCenter.addErrorLabelFromCode('WDT_114');
    }

    @action.bound async handleCancelEdits() {
        if (designStore.wdtGroupsLength > 0) {
            MessageCenter.addWarning(waterwayStore.notifications.unsavedEditsClosePage, [
                {
                    callback: () => {
                        MessageCenter.clearMessages();
                    },
                    text: 'Cancel',
                },
                {
                    callback: async () => {
                        MessageCenter.clearMessages();
                        await this.resetStartEndLength();
                        waterwayStore.reset();
                        this.props.toggleAddWaterwayClicked();
                        this.props.resetPEMReachEdits();
                    },
                    text: 'OK',
                },
            ], 'WDT_115');
        } else {
            MessageCenter.clearMessages();
            await this.resetStartEndLength();
            waterwayStore.reset();
            this.props.toggleAddWaterwayClicked();
            this.props.resetPEMReachEdits();
        }
    }
    @action.bound async onClickGenerateSurface() {
        await this.generateWWSurfaceAndShape('generateSurface');
    }

    @action.bound async onClickSave() {
        await this.saveWaterwayDesign('save');
    }

    @action.bound async onClickSaveCalculate() {
        await this.saveWaterwayDesign('saveAndCalculate');
    }

    waterwayResultsFields = [
        {
            section: 'Waterway Name',
            comment: true,
            fields: {
                alignmentName: 'Alignment',
                status: 'Design Status',
                designedBy: 'Designed By'
            },
            className: 'col-md-5'
        },
        {
            section: 'Design Statistics',
            fields: {
                length: 'Length (ft)',
                totalCut: 'Total Cut (cy)',
                totalFill: 'Total Fill (cy)',

            },
            className: 'col-md-3'
        },
        {
            section: '',
            fields: {
                totalArea: 'Total Area (ac)',
                cutFillBalance: 'Cut/Fill Balance (cy)',
                cutFillRatio: 'Cut/Fill Ratio',
            },
            className: 'col-md-4'
        },
    ];

    @observable showStatusInfoModal = false;
    @observable selectedStatusReachId = "";
    @observable statusError: any[] = [];
    @action.bound onStatusInfoToggle = async (reachId) => {
        this.statusError = [];
        const isLiningWaterway = waterwayStore.waterwayType === 'Lined Waterway' || waterwayStore.currentWaterwayDesignElementTypeId === 19;

        if (isLiningWaterway) {
            const reach = this.currentObject.waterwayDesignStations.find(r => r.reachId === reachId);
            this.selectedStatusReachId = reachId;
            if (reach?.error) {
                const separateCodes = reach.error.split("|");
                for (const code of separateCodes) {

                    const errorParts = code.split('\n');

                    if (errorParts.length > 1) {
                        // multiline with error code and message
                        const firstErrorCode = errorParts[0];
                        const errorMessage = errorParts[errorParts.length - 1];
                        const code = firstErrorCode;
                        this.statusError.push({ code, message: errorMessage });
                    } else {
                        // single error code, fetch description
                        try {
                            const message = await MessageCenter.getMessageFromCode(code);
                            this.statusError.push({ code, message: message });
                        } catch (error) {
                            this.statusError.push({ code, message: `Error code: ${code} (Description not available)` });
                        }
                    }
                }
            }
            this.showStatusInfoModal = !this.showStatusInfoModal;
        } else {
            waterwayStore.openedFromWarningIcon = true;
            this.selectReachForWSC(reachId);
        }
    }

    // ai design experimental code
    /* istanbul ignore next */
    @action.bound async saveAiTrainingData(showSpinner = false) {
        // call saveReachEdits() function in SurfaceDesignerVM --> call API WaterwayDesignToolsReachJsonController.saveReachEditsUsingPOST
        // this.stopEditingMode();

        waterwayStore.clearWaterwayLayers(this.mapView!)

        // if (await this.props.saveReachEdits()) {
        this.props.clearAiTrainingEdits();
        // this.storedWaterwayStations = undefined;

        try {
            if (showSpinner) designStore.setLoader('Refreshing Waterway...');

            try {
                // 1. Call https://eft-set.spatialfrontlab.com/set/waterwaydesign/channelStructureCalculation

                await this.saveUiState('save&Calculate');
                await this.getUiStateAndNotification();

                // 2. Call https://eft-set.spatialfrontlab.com/set/waterwaydesign/getAlignedElementShapeByAlignedElementId
                await this.getAllWaterwayVertex();
            }
            catch (err) {
                console.error('error: getAllWaterwayVertexDtoByAlignedElementDesignParametersIdUsingGET() exportResult is undefined or some other errors', err);
            }

            // Clone object after Save & Calculate
            waterwayStore.wdtGroupsOriginals = [];
            waterwayStore.wdtGroupsOriginals.push(
                {
                    groupCount: 0,
                    currentObject: JSON.parse(JSON.stringify(waterwayStore.waterwayDesignObject))
                }
            );

            await this.profileStore.createReachLineFromSavedWaterway();

        } catch (err) {
            MessageCenter.addError((err as Error).message);
        } finally {
            // await waterwayStore.defaultLiningMaterialChange();
            if (showSpinner) designStore.setLoader('');
        }
    }

    /* istanbul ignore next */
    @action.bound async onReadyHumanFeedbackData() {
        if (designStore.shouldHumanFeedbackOn) {
            try {
                designStore.setLoader('Saving Human Feedback Actions ...');
                const payload = this.tableStore.getHumanFeedbackPayload();
                const response = await axios.post('https://eft-set.spatialfrontlab.com/set/aiwdt/createHumanFeedbackExample', payload)
                const data = await response.data;

                // console.log(payload);
                // console.log(data);

                this.tableStore.humanFeedbackData.length = 0;

                await this.saveAiTrainingData(true);
                // await this.saveWaterwayDesign('save');
            } catch (error) {
                console.log(error);
            } finally {
                designStore.setLoader('');
            }
        }
    }

    /* istanbul ignore next */
    @observable isOpenGenerateReaches: boolean = false;

    /* istanbul ignore next */
    @action.bound async setGenerateReaches(e: any) {
        this.toggleGenerateReaches();
    }

    /* istanbul ignore next */
    @action.bound toggleGenerateReaches() {
        this.isOpenGenerateReaches = !this.isOpenGenerateReaches;
    }

    /* istanbul ignore next */
    @action.bound async runGenerateReaches() {
        const url = 'https://eft-set.spatialfrontlab.com/set/aiwdt/createAutoDefaultReaches';

        const waterway_id = this.currentObject.alignedElementDesignParametersId;
        const payload = {
            alignedElementDesignParamsId: waterway_id,
            minStation: this.minStation,
            maxStation: this.maxStation,
            stationInterval: this.stationInterval,
            cutDepth: this.cupDepth,
            liningMaterial: this.liningMaterial
        };

        this.isOpenGenerateReaches = false;
        try {
            designStore.setLoader("Generating Reaches...")
            const response = await axios.post(url, payload, {
                headers: {
                    'Content-Type': 'application/json'
                    // Add authorization or other headers here if required
                }
            });
            console.log("Waterway_id:", waterway_id);
            console.log('Response:', response.data);
            const data = await response.data;
            const stations = (data.waterwayVertexParamDTOList as Array<any>).filter((v) => v.reachId !== 'START' && v.reachId !== 'END').map((v) => {
                return { reachId: v.reachId, station: Number(v.endStation.replace("+", "")), channelElev: v.channelElev };
            });
            // to do: add rows to waterway table store
            await this.tableStore.addAiRows(stations);

            await this.saveAiTrainingData(true);
        } catch (error) {
            console.error('Error posting data:', error);
        } finally {
            designStore.setLoader("")
        }
    }

    private async callWaterwayError(errorCode, errMessage) {
        if (errorCode === 'WDT_112') {
            MessageCenter.addNotification(errMessage, 'Error', 'WDT_112');
        } else if (errorCode === 'WDT_132') {
            MessageCenter.addNotification(errMessage, 'Error', 'WDT_132');
        } else if (errorCode === 'WDT_130') {
            const stationsIndex = errMessage.indexOf('Fixed');
            const stationPart = errMessage.substring(0, stationsIndex).trim();
            await MessageCenter.addNotificationFromCode('WDT_130', undefined, stationPart);
        } else if (errorCode === 'WDT_131') {
            await MessageCenter.addNotificationFromCode('WDT_131', undefined, errMessage);
        } else if (errorCode === 'WDT_136') {
            MessageCenter.addNotification(errMessage, 'Error', 'WDT_136');
        } else if (errorCode === 'WDT_143') {
            MessageCenter.addNotification(errMessage, 'Error', 'WDT_143');
        } else if (errorCode === 'WDT_144') {
            MessageCenter.addNotification(errMessage, 'Error', 'WDT_144');
        } else if (errorCode === 'WDT_145') {
            MessageCenter.addNotification(errMessage, 'Error', 'WDT_145');
        } else if (errorCode === 'WDT_151') {
            let modifiedErrMessage = errMessage;
            if (errMessage.includes('One or more of the')) {
                modifiedErrMessage = errMessage.split('One or more of the')[0].trim();
            }
            await MessageCenter.addNotificationFromCode('WDT_151', undefined, modifiedErrMessage);
        } else {
            MessageCenter.addError(errMessage);
        }
    }

    /* istanbul ignore next */
    @action.bound async aiRefresh(savingType: 'save' | 'saveAndCalculate' = 'saveAndCalculate') {
        // call saveReachEdits() function in SurfaceDesignerVM --> call API WaterwayDesignToolsReachJsonController.saveReachEditsUsingPOST
        // this.stopEditingMode();
        designStore.setLoader('Refreshing and Rendering Edits...');
        if (await this.props.saveReachEdits()) {
            // this.storedWaterwayStations = undefined;
            if (savingType === 'save') {
                await this.saveUiState('save')
                await this.getUiStateAndNotification();
            }
            else if (savingType === 'saveAndCalculate') {
                designStore.setLoader('Calculating Waterway...');
                // recalculate reach table --> API call
                try {
                    const calculateResponse = await WaterwayDesignToolsController.waterwaySimulationAndValidationUsingPOST(this.currentObject.alignedElementDesignParametersId);
                    if (calculateResponse && calculateResponse.data && !calculateResponse.data.validationPass && calculateResponse.data.errMessage) {
                        const errorCode = calculateResponse.data.errCode;
                        const errMessage = calculateResponse.data.errMessage;

                        // Handle multiple error codes
                        if (errorCode === 'WDT_112' && errMessage.includes('deflection')) {
                            const alignmentIndex = errMessage.indexOf('Alignment');
                            const beforeAlignmentText = errMessage.substring(0, alignmentIndex).trim();
                            await MessageCenter.addNotificationFromCode('WDT_112', undefined, beforeAlignmentText);
                        } else if (errorCode === 'WDT_132') {
                            // MessageCenter.addNotification(errMessage, 'Error', 'WDT_132');
                            console.log('Error WDT_132: ', errMessage);

                        } else {
                            this.callWaterwayError(errorCode, errMessage);
                        }
                    }

                    if (calculateResponse && calculateResponse.data && calculateResponse.data.validationPass) {
                        try {
                            // 1. Call https://eft-set.spatialfrontlab.com/set/waterwaydesign/channelStructureCalculation
                            const channelStructureCalculationResponse = await WaterwayDesignToolsController.channelStructureCalculationUsingPOST(this.currentObject.alignedElementDesignParametersId);
                            const channelStructureCalculationData = channelStructureCalculationResponse.data;
                            if (channelStructureCalculationData.status === null) { // status === null means the calculation is successful, otherwise returns error code
                                await this.saveUiState('save&Calculate');
                                await this.getUiStateAndNotification();
                                await this.generateWWSurfaceAndShape('generateSurface');
                                await this.getWaterwaySummaryBannerReportObj();
                            }
                            else {
                                await MessageCenter.addNotificationFromCode(channelStructureCalculationData.status!)
                            }
                            // 2. Call https://eft-set.spatialfrontlab.com/set/waterwaydesign/getAlignedElementShapeByAlignedElementId
                            await this.getAllWaterwayVertex();
                        }
                        catch (err) {
                            console.error('error: getAllWaterwayVertexDtoByAlignedElementDesignParametersIdUsingGET() exportResult is undefined or some other errors', err);
                        }
                        await this.getWaterwaySummaryBannerReportObj()

                        // Clone object after Save & Calculate
                        waterwayStore.wdtGroupsOriginals = [];
                        waterwayStore.wdtGroupsOriginals.push(
                            {
                                groupCount: 0,
                                currentObject: JSON.parse(JSON.stringify(waterwayStore.waterwayDesignObject))
                            }
                        );
                    }

                    await this.profileStore.createReachLineFromSavedWaterway();
                } catch (err) {
                    MessageCenter.addError((err as Error).message);
                }
            }
            await waterwayStore.defaultLiningMaterialChange();
            designStore.setLoader('');
        }
        designStore.setLoader('');

        // await this.saveWaterwayDesign('saveAndCalculate');

        // await this.saveAiTrainingData()
        // this.resetValues();
    }
    // End: ai design experimental code
}

